/*jshint esversion: 6 */
var dataToSave=false;
var previousval="";
var currentval = "";
var adjustment_input_text = "";
var adjustment_note = "";
var eval_order = "";
var adjustment_link = "";
var notes_link = "";
var map_comps_ids=[];
var map_comps_unit_ids=[];
let check_multi = '';
jQuery(window).on('load', function () {

    var compsInApproaches = [];
    if($('#eval_multi_family').prop('checked') == true){
       let doption = $("select[name='evaluation[comparison_basis]']").val('Unit').change().prop('disabled', 'disabled');
       doption.material_select();
       $('.if-multi-family').removeClass('hide');
       check_multi = true;
    }else{
        $("select[name='evaluation[comparison_basis]']").removeAttr("disabled");
    }

    iterateUnitControls();

    var segments = location.pathname.split("/");
    let search = location.search.split("/");

    if (isInArray('evaluations', segments) || isInArray('evaluations', search)) {
        ApproachCalculator.check_unit_val =   ApproachCalculator.calculateUnits();
        var initializeForms = function () {
            if (isInArray('overview', segments) && !isInArray("comps", segments)) {
                setOverviewFields();
            } else if (isInArray('income', segments)) {
                IncomeApproach.init();
                EvaluationsCommons.init();
                ApproachCalculator.calculateIncomeApproach();
            } else if (isInArray('leaseComps', segments) || isInArray('leaseComps', search)) {
                setLeaseCompsFields();
                EvaluationsCommons.init();
                initImageCropper();
            } else if (isInArray('capComps', segments) || isInArray('capComps', search)) {
                setCAPCompsFields();
                EvaluationsCommons.init();
                initImageCropper();
            } else if (isInArray('sales', segments) || isInArray('sales', search)) {
                setSalesApproachFields();
                EvaluationsCommons.init();
                initImageCropper();
            } else if (isInArray('multiFamilyComps', segments) || isInArray('multiFamilyComps', search)) {
                setMultiFamilyApproachFields();
                EvaluationsCommons.init();
                initImageCropper();
            } else if (isInArray('cost', segments) || isInArray('cost', search)) {
                setCostApproachFields();
                EvaluationsCommons.init();
                initImageCropper();
            } else if (isInArray('cost-improvement', segments)) {
                setCostApproachImprovementEvaluationFields();
                EvaluationsCommons.initWeightSetting();
                initType();
            } else if (isInArray('exhibits', segments)) {
                setExhibitFields();
                sortExhibitRows();
                EvaluationsCommons.initWeightSetting();
                initializeUploadFunctions();
                ApproachCalculator.updateSidebar();
            } else if (isInArray('review', segments)) {
               // setReviewFields();
                loadWeightEvents();
                loadlinkMergeEvents();
                showHideFields();
            } else if (isInArray('evaluations', segments) && segments.length < 3) {
                loadClientsList();
            }
            setBreadcrumb();
        };
        var showHideFields = function () {
            if(!$('.linked_eval_id').length){
                $('.linked_evals_tbl').addClass('hide');
                $('.additional_row_action').addClass('hide');
                $('.get_start_row').removeClass('hide');
            }else{
                let flag = 0;
                $('.linked_eval_type').each(function() { 
                    if($(this).val() == "residential"){
                        flag = 1;
                    }
                });
                if(flag){
                    $('.if-residential').removeClass('hide');
                }else{
                    $('.if-residential').addClass('hide');
                }
            }
        };

        var loadlinkMergeEvents = function () {
            $(document).on('click', '.add_another_eval', function () {
                $('#select-evals').modal('open');
            });
            $(document).on('click', '.get_evals', function () {
                loadEvalsListings();
            });
            $(document).on('click', '.save_linked_evals', function () {
                let form = $("#form_linked_evals");
                let data = new FormData(form[0]);
                saveLinkedEvals(data);
            });
            $(document).on('click', '.get_start', function () {
                $(".get_start_row").addClass('hide');
                $('.linked_evals_tbl').removeClass('hide');
            });
            $(document).on('click', '.adjustedSearch', function () {
                $('.advance_search_btn').addClass('hide');
                $('.advance_filter_form').removeClass('hide');
                $('.get_evals').removeClass('hide');
                $('#eval_tbl_wrap').hide();
            });
            $(document).on('click', '.remove_linked_row', function () {
                $(this).parent().parent().remove();
                if(!$('.additional_row').length){
                    $('.additional_row_action').addClass('hide');
                    $('.additional_row').remove();
                    $('.linked_evals_tbl').addClass('hide');
                    $(".get_start_row").removeClass('hide');
                    let form = $("#form_linked_evals");
                    let data = new FormData(form[0]);
                    saveLinkedEvals(data);
                }
                showHideFields();
            });

            $(document).on('click', '.selectEvalsBtn', function () {
                showAdvanceLoading();
                $(".selectEvalsBtn").attr('disabled',true);
                setTimeout( function() { 
                    selectEvals();
                    $(".selectEvalsBtn").attr('disabled',false);
                    hideAdvanceLoading();
                },200);
            });
        };

        var saveLinkedEvals = function (data) {
            $.ajax({
                type: "POST",
                url: $("body").data("base-url") + "evaluations/saveLinkedEvals",
                data: data,
                async:false,
                cache: false,
                contentType: false,
                processData: false,
                beforeSend: function (xhr) {
                    showLoading();
                },
                success: function (responseText) {
                    let response = JSON.parse(responseText);
                    if (response.status.localeCompare("success") === 0) {
                        saveToast();
                        hideLoading();
                    }
                }
            });
        };

        var selectEvals = function() {
            let ids=[];
            let count=0;
            
            $('.select_eval').each(function() {
                if($(this).is(":checked") )
                {
                    ids.push($(this).val());
                    count++;
                }
            });
                
            if(!count)
                return Materialize.toast('Please select comps.', 3000, 'red');

            $('#select-evals').modal('close');
            loadEvalsEntry(ids);
            clearEvalFilter();
        };

        var loadEvalsEntry = function (id) {
            let eval_search_mode = 'commercial';
            let eval_type = 'Comm';
            if ($("#eval_search_mode").is(":checked")) {
                eval_search_mode = 'residential';
                eval_type = 'Res';
            }
            $.ajax({
                type: "GET",
                async:false,
                url: $("body").data("base-url") + "evaluations/getEvals",
                data: { id: id, eval_search_mode: eval_search_mode },
                success: function (responseText) {
                    const evals = JSON.parse(responseText);
                    let row = '';
                    $.each(evals, function(i, item) {
                        let flag = 1;
                        $('.linked_eval_id').each(function() { 
                            if($(this).val() == item.id){
                                flag = 0;
                            }
                        });
                        
                        let eval_name = '';
                        if ($("#eval_search_mode").is(":checked")) {
                            eval_name = item.property_name;
                        }else{
                            eval_name = item.business_name;
                        }
                        if(flag){
                            let index = parseInt($("#counter").val())+1;
                            $("#counter").val(index);
                            row += '<tr class="additional_row">'+
                                '<td>'+
                                    '<input type="hidden" class="linked_eval_id" name="evaluation[linked_evals]['+index+'][id]" value="'+item.id+'">'+
                                    '<input type="hidden" class="linked_eval_type" name="evaluation[linked_evals]['+index+'][eval_type]" value="'+eval_search_mode+'">'+
                                    eval_name+', '+item.street_address+', '+item.city+', '+item.state.toUpperCase()+', '+item.zipcode+
                                '</td>'+
                                '<td class="if-residential hide">'+eval_type+'</td>'+
                                '<td><div class="input-field col">'+
                                        '<input type="text" name="evaluation[linked_evals]['+index+'][label]" value="Additional" maxlength="20">'+
                                    '</div>'+
                                '</td>'+
                                '<td>'+
                                    '<input type="checkbox" name="evaluation[linked_evals]['+index+'][executive]" id="evaluation[linked_evals]['+index+'][executive]" value="0" onchange="updateValue(this)">'+
                                    '<label for="evaluation[linked_evals]['+index+'][executive]"></label>'+
                                '</td>'+
                                '<td>'+
                                    '<input type="checkbox" name="evaluation[linked_evals]['+index+'][overview]" id="evaluation[linked_evals]['+index+'][overview]" value="0" onchange="updateValue(this)">'+
                                    '<label for="evaluation[linked_evals]['+index+'][overview]"></label>'+
                                '</td><td>';
                                if(item.comp_type == 'building_with_land'){
                                    row +=  '<input type="checkbox" name="evaluation[linked_evals]['+index+'][specs]" id="evaluation[linked_evals]['+index+'][specs]" value="0" onchange="updateValue(this)">'+
                                            '<label for="evaluation[linked_evals]['+index+'][specs]"></label>';
                                }else{
                                    row += 'N/A';
                                }
                                row += '</td><td>'+
                                    '<input type="checkbox" name="evaluation[linked_evals]['+index+'][map]" id="evaluation[linked_evals]['+index+'][map]" value="0" onchange="updateValue(this)">'+
                                    '<label for="evaluation[linked_evals]['+index+'][map]"></label>'+
                                '</td>'+
                                '<td>'+
                                    '<input type="checkbox" name="evaluation[linked_evals]['+index+'][boundary]" id="evaluation[linked_evals]['+index+'][boundary]" value="0" onchange="updateValue(this)">'+
                                    '<label for="evaluation[linked_evals]['+index+'][boundary]"></label>'+
                                '</td> <td>';
                                if(item.has_sales_approach !== "0" && item.has_sales_approach != null){
                                    row +=  '<input type="checkbox" name="evaluation[linked_evals]['+index+'][sca]" id="evaluation[linked_evals]['+index+'][sca]" value="0" onchange="updateValue(this)">'+
                                            '<label for="evaluation[linked_evals]['+index+'][sca]"></label>';
                                }else{
                                    row += 'N/A'+
                                           '<input type="hidden" name="evaluation[linked_evals]['+index+'][sca]" id="evaluation[linked_evals]['+index+'][sca]" value="N/A">';    
                                }
                                row += '</td> <td>';
                                if(item.has_income_approach !== "0" && item.has_income_approach != null){
                                    row +=  '<input type="checkbox" name="evaluation[linked_evals]['+index+'][income]" id="evaluation[linked_evals]['+index+'][income]" value="0" onchange="updateValue(this)">'+
                                            '<label for="evaluation[linked_evals]['+index+'][income]"></label>';
                                }else{
                                    row +=  'N/A'+
                                            '<input type="hidden" name="evaluation[linked_evals]['+index+'][income]" id="evaluation[linked_evals]['+index+'][income]" value="N/A">';
                                }
                                row += '</td> <td>';
                                if(item.has_lease_comps !== "0" && item.has_lease_comps != null){
                                    row +=  '<input type="checkbox" name="evaluation[linked_evals]['+index+'][lease]" id="evaluation[linked_evals]['+index+'][lease]" value="0" onchange="updateValue(this)">'+
                                            '<label for="evaluation[linked_evals]['+index+'][lease]"></label>';
                                }else{
                                    row += 'N/A'+
                                           '<input type="hidden" name="evaluation[linked_evals]['+index+'][lease]" id="evaluation[linked_evals]['+index+'][lease]" value="N/A">';    
                                }
                                row += '</td> <td>';
                                if(item.has_cap_comps !== "0" && item.has_cap_comps != null){
                                    row +=  '<input type="checkbox" name="evaluation[linked_evals]['+index+'][cap_rate]" id="evaluation[linked_evals]['+index+'][cap_rate]" value="0" onchange="updateValue(this)">'+
                                            '<label for="evaluation[linked_evals]['+index+'][cap_rate]"></label>';
                                }else{
                                    row += 'N/A'+
                                           '<input type="hidden" name="evaluation[linked_evals]['+index+'][cap_rate]" id="evaluation[linked_evals]['+index+'][cap_rate]" value="N/A">';    
                                }
                                row += '</td> <td>';
                                if(item.has_multi_family !== "0" && item.has_multi_family != null){
                                    row +=  '<input type="checkbox" name="evaluation[linked_evals]['+index+'][multi_family]" id="evaluation[linked_evals]['+index+'][multi_family]" value="0" onchange="updateValue(this)">'+
                                            '<label for="evaluation[linked_evals]['+index+'][multi_family]"></label>';
                                }else{
                                    row += 'N/A'+
                                           '<input type="hidden" name="evaluation[linked_evals]['+index+'][multi_family]" id="evaluation[linked_evals]['+index+'][multi_family]" value="N/A">';    
                                }
                                row += '</td> <td>';
                                if(item.has_cost_approach !== "0" && item.has_cost_approach != null){
                                    row +=  '<input type="checkbox" name="evaluation[linked_evals]['+index+'][cost]" id="evaluation[linked_evals]['+index+'][cost]" value="0" onchange="updateValue(this)">'+
                                            '<label for="evaluation[linked_evals]['+index+'][cost]"></label>';
                                }else{
                                    row += 'N/A'+
                                    '<input type="hidden" name="evaluation[linked_evals]['+index+'][cost]" id="evaluation[linked_evals]['+index+'][cost]" value="N/A">'; 
                                }
                                row += '</td>'+
                                '<td>'+
                                    '<i href="#!" class="delete red-text remove_linked_row"><i class="material-icons">remove_circle</i></i>'+
                                '</td>'+
                            '</tr>';
                        }else{
                            Materialize.toast(eval_name+ " is already linked",1000);
                        }
                    });
                    $('.additional_row_action').removeClass('hide');
                    $("#linked_evals_table tbody").append(row);
                    showHideFields();
                    clearEvalFilter();
                    dataToSave=true;
                },
                failure: function (errMsg) {
                    console.error("error:" + errMsg);       
                    hideAdvanceLoading();
                }
            }).done(function () {
                hideAdvanceLoading();
            });
        };

        var loadEvalsListings = function () {
            $('.advance_search_btn').removeClass('hide');
            $('.advance_filter_form').addClass('hide');
            $('.get_evals').addClass('hide');
            let formValues= $("#form_modal").serialize();  
            $.ajax({
                type: "POST",
                url: $("body").data("base-url") + "evaluations/get_evals",
                data: formValues,
                beforeSend: function (xhr) {
                    showAdvanceLoading();
                },
                success: function (responseText) {
                    EvaluationsCommons.resetMarkers();
                    let dataTable = $("#evals-modal-table").DataTable();
                    dataTable.destroy();
                    $("#evals-modal-table").html();
                    let eval = JSON.parse(responseText);
                    $("#eval_tbl_wrap").show();
                    if (eval.response == "") {
                        $(".selectCompsBtn").hide();
                    } else {
                        $(".selectCompsBtn").show();
                    }
                    if ($("#results_format").is(":checked")) {
                        $("#evals-modal-table").addClass("hide");
                        if (eval.evals_data == "No record found") {
                            $("#response_div").removeClass("hide");
                        } else {
                            $("#response_div").addClass("hide");
                        }
                    } else {
                        $("#evals-modal-table").removeClass("hide");
                        $("#response_div").addClass("hide");
                    }
                    $("#evals-modal-table").html(eval.response);
                    const table  = $("#evals-modal-table").DataTable({
                        searching: false,
                        lengthChange: false,
                        pagination: false,
                        order: [[2, "desc"]],
                        paginate: false,
                    });
                    // Removing default style as it is causing table not to expand full width 
                    const headers = table.columns().header();
                    headers.each(function(th) {
                        $(th).removeAttr("style");
                    });
                    $('#'+$('[name="evaluation[id]"]').val()).remove();
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    if (jqXHR.status == 500) {
                        Materialize.toast(errorThrown,1000);
                    } else {
                        Materialize.toast('Unexpected error.',1000);
                    }
                    hideAdvanceLoading();
                }
            }).done(function () {
                hideAdvanceLoading();
            });
        };

        var loadWeightEvents = function () {
            $('input[name="income_weight"]').on('keyup paste', _.debounce(ApproachCalculator.redefineWeight, 500));
            $('input[name="sales_weight"]').on('keyup paste', _.debounce(ApproachCalculator.redefineWeight, 500));
            $('input[name="cost_weight"]').on('keyup paste', _.debounce(ApproachCalculator.redefineWeight, 500));
        };

        var loadClientsList = function () {
            hideShowNextBtn();

            $('select[name=clients]').change(hideShowNextBtn);

            $('.clients-next').click(function () {
                var id = $('select[name=clients]').val();
                onSelectClient(id);
            });
        };

        var hideShowNextBtn = function () {
            var id = $('select[name=clients]').val();

            if (id !== null && id !== 'undefined' && id.length > 0) {
                $('.clients-next').removeClass('hide');
            } else {
                $('.clients-next').addClass('hide');
            }
        };

        var removeFile = function (id, field, file_id, callback) {
            startLoading('.approach-container');
            $.ajax({
                type: "POST",
                url: $("body").data("base-url") + "evaluations/remove_file",
                data: {
                    id: id,
                    field: field,
                    file_id: file_id
                },
                success: function (responseText) {
                    var comp = JSON.parse(responseText);

                    if (comp.status === 'success') {
                        if (callback !== undefined) {
                            callback();
                        }
                    }

                    if (comp.message) {
                        Materialize.toast(comp.message, 2000);
                    }
                },
                failure: function (errMsg) {
                    console.error("error:" + errMsg);
                }
            }).done(function () {
                stopLoading('.approach-container');
            });
        };

        var removeExhibit = function (id, field, file_id, callback) {
            startLoading('.approach-container');
            $.ajax({
                type: "POST",
                url: $("body").data("base-url") + "evaluations/remove_exhibit",
                data: {
                    id: id,
                    field: field,
                    file_id: file_id
                },
                success: function (responseText) {
                    var comp = JSON.parse(responseText);

                    if (comp.status === 'success') {
                        if (callback !== undefined) {
                            callback();
                        }
                    }

                    if (comp.message) {
                        Materialize.toast(comp.message, 2000);
                    }
                },
                failure: function (errMsg) {
                    console.error("error:" + errMsg);
                }
            }).done(function () {
                stopLoading('.approach-container');
            });
        };

        var removeDownload = function (data) {
            var input =
                "<div id='" + data.name + "' class='input-field'>" +
                "<div class='approach-field-label inline'>" + data.label + "</div>" +
                "<span class='file-field inline'>" +
                "<span class='file-path-wrapper'>" +
                "<input type='file' name='" + data.name + "' accept='.jpeg,.jpg,.png,.pdf'>" +
                "<input placeholder='Upload (.pdf,.jpg)' value='' class='file-path validate' type='text'>" +
                "</span>" +
                "</span>" +
                "</div>";

            var div = $("#" + data.name);

            if (typeof (data.id) !== 'undefined' && data.id !== null) {
                removeFile(data.id, data.name, false, function () {
                    div.replaceWith(input);
                    initializeUploadFunctions();
                });
            }
        };

        var removeAdditionalExhibit = function (obj) {
            if (obj) {
                var compId = $("input[name='evaluation[id]']").val();

                if (typeof (compId) !== 'undefined' && compId !== null) {
                    removeExhibit(compId, obj.attr('data-field-name'), obj.attr('data-exhibit-id'), function () {
                        obj.parent().parent().parent().remove();
                    });
                }
            }
        };

        /*var setReviewFields = function () {
            $(document).on('click', '.save-and-exit-evaluation', function () {
                $.ajax({
                    type: "POST",
                    url: $("body").data("base-url") + "evaluations/post",
                    data: {
                        evaluation: {
                            id: $("input[name='evaluation[id]']").val(),
                            submitted: 1, //true
                            position: 'overview'
                        }
                    },
                    success: function (responseText) {
                        var response = JSON.parse(responseText);
                        if (response.status === 'success') {
                            window.location.href = $("body").data("base-url") + "evaluations";
                        } else {
                            Materialize.toast(response.message, 2000);
                        }
                    }
                });
            });
        };*/

        var initializeUploadFunctions = function () {
            $("input:file.comps-urls").change(function () {
                var file = this.files[0];
                uploadFile(file, $(this).attr('name'), $('input[name="evaluation[id]"]').val(), $(this));
            });

            $("input:file[name='exhibits']").change(function () {
                var file = this.files[0];
                uploadExhibit(file, $(this).attr('name'), $('input[name="evaluation[id]"]').val(), $(this));
            });

            $("input[name='title']").change(function () {
                var id = $(this).closest('tr').attr('data-id');
                var field = 'filename';
                var value = $(this).val();
                updateExhibit(id, field, value);
            });
        };

        var uploadFile = function (file, field, id) {
            if (window.FormData === undefined) {
                alert('Please update your browser to a newer version to use this feature.');
            } else {
                var formData = new FormData();
                formData.append(field, file);
                formData.append('id', id);
                formData.append(field, '');
                startLoading('.approach-container');
                $.ajax({
                    type: 'POST',
                    url: $('body').attr('data-base-url') + 'evaluations/post_file',
                    data: formData,
                    contentType: false,
                    processData: false,
                    success: function (responseTxt) {
                        var response = JSON.parse(responseTxt);

                        if (response.message) {
                            Materialize.toast(response.message, 2000);
                        }

                        location.reload();
                    }
                }).done(function () {
                    stopLoading('.approach-container');
                });
            }
        };

        var uploadExhibit = function (file, field, id) {
            if (window.FormData === undefined) {
                alert('Please update your browser to a newer version to use this feature.');
            } else {
                var formData = new FormData();

                formData.append('file', file);
                formData.append('id', id);
                formData.append('field', field);
                formData.append('exhibit', true);

                startLoading('.approach-container');
                $.ajax({
                    type: 'POST',
                    url: $('body').attr('data-base-url') + 'evaluations/post_exhibit',  //Server script to process data
                    data: formData,
                    contentType: false,
                    processData: false,
                    success: function (responseTxt) {
                        var response = JSON.parse(responseTxt);

                        if (response.message) {
                            Materialize.toast(response.message, 2000);
                        }

                        location.reload();
                    }
                }).done(function () {
                    stopLoading('.approach-container');
                });
            }
        };

        var updateExhibit = function (id, field, value) {
            if (window.FormData === undefined) {
                alert('Please update your browser to a newer version to use this feature.');
            } else {
                var formData = new FormData();

                formData.append('id', id);
                formData.append('field', field);
                formData.append('value', value);

                startLoading('.approach-container');
                $.ajax({
                    type: 'POST',
                    url: $('body').attr('data-base-url') + 'evaluations/put_exhibit',
                    data: formData,
                    contentType: false,
                    processData: false,
                    success: function (responseTxt) {
                        var response = JSON.parse(responseTxt);

                        if (response.message) {
                            // Materialize.toast(response.message, 2000);
                        }
                    }
                }).done(function () {
                    stopLoading('.approach-container');
                });
            }
        };

        var fill = function (data, template) {
            Object.keys(data).forEach(function (key) {
                var placeholder = "{{" + key + "}}";
                var value = data[key];
                while (template.indexOf(placeholder) !== -1) {
                    template = template.replace(placeholder, value);
                }
            });
            return template;
        };

        var setExhibitFields = function () {
            var comp_id = $("input[name='evaluation[id]']").val();

            $(document).on('click', '.delete-county-details-url', function () {
                deleteConfirm(function () {
                    return removeDownload({ 'label': 'County Details', 'name': 'county_details_url', 'id': comp_id });
                });
            });

            $(document).on('click', '.delete-county-tax-url', function () {
                deleteConfirm(function () {
                    return removeDownload({ 'label': 'County Tax', 'name': 'county_tax_url', 'id': comp_id });
                });
            });

            $(document).on('click', '.delete-subdivision-survey-url', function () {
                deleteConfirm(function () {
                    return removeDownload({
                        'label': 'Subdivision/Survey',
                        'name': 'subdivision_survey_url',
                        'id': comp_id
                    });
                });
            });

            $(document).on('click', '.remove-exhibit-from-evaluation', function () {
                var $this = $(this);
                deleteConfirm(function () {
                    return removeAdditionalExhibit($this);
                }, event);
            });

            $(document).on('change', 'input[name=title]', function () {

            });

            $(document).on('click', '.add-new-evaluation-exhibit', function () {
                var template = $('#additional-exhibit-template').html();
                $('.add-new-exhibit-button').first().before(template);
                initializeUploadFunctions();
            });
        };

        var sortExhibitRows = function () {
            var container = document.getElementById('sort-exhibits');
            var rows = container.children;

            var nodeListForEach = function (array, callback, scope) {
                for (var i = 0; i < array.length; i++) {
                    callback.call(scope, i, array[i]);
                }
            };

            var sortableTable = dragula([container], {
                moves: function (el, container, handle) {
                    return handle.classList.contains('sort-row');
                }
            });

            sortableTable.on('dragend', function () {
                nodeListForEach(rows, function (index, row) {
                    row.getElementsByClassName("row-order")[0].setAttribute("data-field-order", index + 1);

                    // Iterate through rows, and update orders
                    $('#sort-exhibits tr').each(function () {
                        var id = $(this).attr('data-id');
                        var order = $(this).find('td:last-child span.row-order').attr('data-field-order');

                        updateExhibit(id, 'order', order);
                    });
                });
            });
        };

        var setEvaluationType = function () {
            $('select[name="evaluation[type]"]').change(function () {
                if ($(this).val() === 'sale') {
                    $("[data-eval-type=sale]").removeClass('hide');
                    $("[data-eval-type=non-sale]").addClass('hide');
                } else {
                    $("[data-eval-type=sale]").addClass('hide');
                    $("[data-eval-type=non-sale]").removeClass('hide');
                }
            });

            if ($('select[name="evaluation[type]"]').val() === 'sale') {
                $("[data-eval-type=sale]").removeClass('hide');
                $("[data-eval-type=non-sale]").addClass('hide');
            } else {
                $("[data-eval-type=sale]").addClass('hide');
                $("[data-eval-type=non-sale]").removeClass('hide');
            }
        };

        var setOverviewFields = function () {

            var utilSelect = $("#utilities_select");
            var utilInput = $('#utilities_other').parent('.input-field');

            // Allow 'Other' selection of Utilities
            var checkUtils = function (e) {
                if (e.val() === 'other') {
                    utilInput.removeClass('hide');
                } else if (!utilInput.hasClass('hide')) {
                    utilInput.addClass('hide');
                }
            };

            utilSelect.on('change', function () {
                checkUtils($(this));
            });

            // If 'other' is the set utility, then show the utilities input
            checkUtils(utilSelect);


            $('form#evaluation-form input,textarea,select').blur(function () {
                $(this).valid();
            });

            $('form#evaluation-form select').change(function () {
                $(this).valid();
            });


            setEvaluationType();

            $(document).on('click', '.add-additional-traffic-count', function () {
                var div = $('.traffic-count-row');

                var clone = div.last().clone();
                clone.find('input:not(.hidden-field)').val('');
                clone.find('select.traffic_count_adt').val('');
                clone.closest('.traffic-count-row').find('.traffic_count_value').addClass('hidetraffic');
                div.last().after(clone);
                iterateTrafficCounts();
                // $('.space').mask("#,##0", { reverse: true });
                
                $('.space').each(function (index, value) {
                    x1 = $(this).val().replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ",") || '';
                    $(this).val(x1);
                });
                var trafficCount = $('.traffic-count-row');
                var trafficCount_row = trafficCount.last();
                trafficCount_row.find("select.traffic_count_adt").val('').trigger("change");

            });

            $(document).on('click', '.delete-additional-traffic-count', function () {
                if ($('.traffic-count-row').length === 1) {
                    $(this).closest('.traffic-count-row').find('input').val('');
                } else {
                    $(this).closest('.traffic-count-row').remove();
                }
                iterateTrafficCounts();
                var trafficCount = $('.traffic-count-row');
                var trafficCount_row = trafficCount.first();
                trafficCount_row.find("input[name='evaluation[traffic_counts][index][street_address]']").trigger("change");
            });

            iterateTrafficCounts();
            initPropertyTypeSqftEvent();
        };

        var initPropertyTypeSqftEvent = function () {
            if ($('.zonings[data-attribute="sq_ft"]').length > 0) {
                $('.zonings[data-attribute="sq_ft"]').keyup(_.debounce(calculateBuildingSize, 500));
            }

            calculateBuildingSize();
        };

        var iterateTrafficCounts = function () {
            var rows = $('.traffic-count-row');
            var rowsTotal = rows.length;
            rows.each(function (i) {
                if (rowsTotal > (i + 1)) {
                    $(this).find('.additional-traffic-count').addClass('hide');
                } else if (rowsTotal === (i + 1)) {
                    $(this).find('.additional-traffic-count').removeClass('hide');
                }

                if (i > 0) {
                    $(this).find('.delete-additional-traffic-count').removeClass('hide');
                }
                //limiting traffic counts to allow upto 4 only fix[START]
                if (i + 1 == 4) {
                    $(this).find('.additional-traffic-count').addClass('hide');
                }
                //[STOP]
                $(this).find('.tooltipped').tooltip();
                $(this).find('select').material_select();
            });
        };

        var capitalize=function (word) {
            return word[0].toUpperCase() + word.slice(1).toLowerCase();
        };

        var setCompFields = function (template, comp, units) {
            let size_by_comp_basis = 0;
            for (var key in comp) {
                var field = template.find('span.' + key);

                if (field) {
                    if (comp[key + '_for_text_view']) {
                        field.text(comp[key + '_for_text_view']);
                    } else {
                        if (comp[key + '_for_view']) {
                            if(key==='land_size' || key==='price_square_foot'){
                                var land_size = parseFloat(comp.land_size);
                                if($('#selected_comp_type').val()==='land_only' && $('#selected_analysis_type').val()==='$/Acre'){
                                    var land_size_for_calculation = parseFloat(comp.land_size);
                                    if(comp.land_dimension==='SF')
                                    {
                                        land_size_for_calculation = parseFloat(comp.land_size/43560);
                                        land_size = (comp.land_size/43560).toFixed(3);
                                    }else{
                                        land_size = land_size.toFixed(3);
                                    }
                                    var price_square_foot = 0;
                                    var sale_price = parseFloat(comp.sale_price);
                                    price_square_foot = (land_size_for_calculation > 0) ? parseFloat(sale_price/land_size_for_calculation).toFixed(2) : 0;
                                    if(key==='land_size'){
                                        field.text((land_size > 0) ? land_size.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")+" AC" : 'N/A');
                                    }else if(key==='price_square_foot'){
                                        if(location.pathname.indexOf('/leaseComps') !== -1){
                                            price_square_foot = (parseFloat(comp.price_square_foot)*43560).toFixed(2);
                                            template.find("input[name='single_comp[price_acre]']").val(price_square_foot);
                                        }else{
                                            template.find("input[name='single_comp[price_acre]']").val(price_square_foot);
                                        }
                                        field.text("$"+price_square_foot.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")+" /AC");
                                    }
                                }else{
                                    if($('#comparison_basis_field').val() != 'SF' && key == 'price_square_foot' && location.pathname.indexOf('/evaluations/cost') == -1){
                                        size_by_comp_basis = 0;
                                        let cal_field = ($('#comparison_basis_field').val()).replace(/ /g, "_").toLowerCase();
                                        for (let i = 0; i < comp['zonings'].length; i++) {
                                            size_by_comp_basis += comp['zonings'][i][cal_field] << 0;
                                        }
                                        let price_psf = (comp.sale_price/size_by_comp_basis).toFixed(2);
                                        if(comp.type == 'lease'){
                                            if(comp.lease_rate_unit == 'monthly'){
                                                price_psf = ((parseFloat(comp.lease_rate)/parseFloat(size_by_comp_basis))/12).toFixed(2);
                                            }else if(comp.lease_rate_unit == 'annual'){
                                                price_psf = (parseFloat(comp.lease_rate)/parseFloat(size_by_comp_basis)).toFixed(2);
                                            }
                                        }
                                        comp.price_square_foot = price_psf;
                                        field.text("$"+price_psf.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,"));
                                    }
                                    else if(comp.type == 'lease'){
                                        field.text(comp[key + '_for_view']);
                                    }
                                    else if(key==='price_square_foot'){
                                        if(isInArray('cost', segments)){
                                            let land_size = parseFloat(comp.land_size);
                                            if($("input[name='evaluation[landDimension]']").val() === 'ACRE'){
                                                if(comp.land_dimension !== 'ACRE'){
                                                    land_size = (comp.land_size/43560).toFixed(3);
                                                }
                                            }else{
                                                if(comp.land_dimension === 'ACRE'){
                                                    land_size = (comp.land_size*43560).toFixed(3);
                                                }
                                            }
                                            price_square_foot = (land_size > 0) ? parseFloat(comp.sale_price/land_size).toFixed(2) : "0";
                                            // template.find("input[name='single_comp[price_acre]']").val(price_square_foot);
                                            field.text((price_square_foot).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,"));
                                        }else{
                                            field.text(comp[key + '_for_view']);
                                        }
                                    }
                                    else{
                                        field.text(comp[key + '_for_view']);
                                    }
                                    if(key==='land_size' && comp.land_dimension==='ACRE'){
                                        land_size = land_size.toFixed(3);
                                    }
                                    if (key ==='land_size' && $("input[name='evaluation[landDimension]']").val() === 'ACRE' && comp.land_dimension === 'SF'){
                                        let land_size_for_view = (land_size/43560).toFixed(3);
                                        field.text((land_size_for_view > 0) ? land_size_for_view.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")+" AC" : 'N/A');
                                    }else {
                                        if ((key ==='land_size' && $("input[name='evaluation[landDimension]']").val() === 'SF'  && comp.land_dimension === 'ACRE' )) {
                                            let land_size_for_view = (land_size * 43560).toFixed(2);
                                            field.text((land_size_for_view > 0) ? land_size_for_view.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")+" SF" : 'N/A');
                                        }else if(key==='land_size' && comp.land_dimension==='ACRE'){
                                            land_size_for_view = land_size ;
                                            field.text((land_size_for_view > 0) ? land_size_for_view.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")+" AC" : 'N/A');
                                        }
                                    }
                                }
                            }else{
                                if($('#comparison_basis_field').val() != 'SF' && key == 'building_size' && location.pathname.indexOf('/evaluations/cost') == -1){
                                    size_by_comp_basis = 0;
                                    let cal_field = ($('#comparison_basis_field').val()).replace(/ /g, "_").toLowerCase();
                                    for (let i = 0; i < comp['zonings'].length; i++) {
                                        size_by_comp_basis += comp['zonings'][i][cal_field] << 0;
                                    }
                                    field.text(size_by_comp_basis.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,"));
                                    template.find('span.building_size_sf').text(comp[key + '_for_view']);
                                // }else if($('#comparison_basis_field').val() == 'SF' && key == 'building_size' && location.pathname.indexOf('/evaluations/cost') != 0){
                                }else if(key == 'building_size' && location.pathname.indexOf('/evaluations/cost') != 0){
                                    size_by_comp_basis = comp.building_size;
                                    field.text(comp[key + '_for_view']);
                                }else{
                                    field.text(comp[key + '_for_view']);
                                }
                                
                            }
                        } else {
                            // get property type from zoning array. 
                            if  (key === "zonings" && Array.isArray(comp[key]) && comp[key].length) {
                                field.text(comp[key][0].zone_for_view+' / '+comp[key][0].subzone_for_view);
                            } else {
                                let included_utilities = '';
                                if(key == 'included_utilities'){
                                    included_utilities = 'N/A';
                                    if(comp[key]){
                                        // included_utilities = String(JSON.parse(comp[key]));
                                        included_utilities = comp[key].map(function(obj) {
                                            return obj.utility;
                                        }).join(', ');
                                    }
                                    if(comp['other_include_utilities']){
                                        if(included_utilities != "")
                                            included_utilities = included_utilities+', '+comp['other_include_utilities'];
                                        else
                                            included_utilities = comp['other_include_utilities'];
                                    }
                                    template.find('span.included_utilities_for_view').text(included_utilities);
                                }
                                if(key=="year_built" || key=="year_remodeled" ){
                                    if(key=="year_built" && comp[key] === null && comp.year_remodeled !== null)
                                    {
                                        field.text("N/A / ");
                                    }
                                    else if(key=="year_built" && (comp.year_built && comp.year_built!== null && comp.year_remodeled && comp.year_remodeled!==null))
                                    {
                                        field.text(comp[key]+" / ");
                                    }
                                    else if(key=="year_remodeled" && comp[key] === null && comp.year_built !== null)
                                    {
                                        field.text("/ N/A");
                                    }
                                    else{
                                        field.text(comp[key]);
                                    }
                                }
                                else if (comp[key]) {
                                    field.text(comp[key]);
                                }
                                else{
                                        field.text('');
                                }
                            }
                        }
                    }
                    if (key === "price_square_foot" && isInArray('sales', segments)) {
                        field.text(comp.price_psf);
                    } else if (key === "price_square_foot" && isInArray('cost', segments)) {
                        field.text(comp.price_psf);
                    }
                     
                    if(key == "parking"){
                        if(comp.parking == null || comp.parking == ''){
                            field.text("N/A");
                        }
                    }
                    if(key === 'property_units' && isInArray('multiFamilyComps', segments) ){
                        let unit_id = 0;
                        units.forEach((value, index, self) => {
                            if(comp.id === self[index]['id']){
                                unit_id = self[index]['unit_id'];
                            }
                        });
                        let index_no = comp.property_units.findIndex((obj => obj.id == unit_id));
                        template.find('.property_units').text('(' + comp.property_units[index_no].unit_count + ') ' + comp.property_units[index_no].beds + '/' + comp.property_units[index_no].baths);   
                        template.find("input[name='evaluation[multi_family_approach][comps][index][property_unit]']").attr('value','(' + comp.property_units[index_no].unit_count + ') ' + comp.property_units[index_no].beds + '/' + comp.property_units[index_no].baths);   
                        template.find("input[name='evaluation[multi_family_approach][comps][index][property_unit_id]']").attr('value',unit_id);   
                        template.find('.avg_monthly_rent').text((comp.property_units[index_no].avg_monthly_rent !== null) ? ( comp.property_units[index_no].avg_monthly_rent ).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,") : parseFloat(0).toFixed(2));
                        template.find("input[name='single_comp[avg_monthly_rent]']").attr('value',comp.property_units[index_no].avg_monthly_rent);
                        template.find("input[name='evaluation[multi_family_approach][comps][index][avg_monthly_rent]']").attr('value',comp.property_units[index_no].avg_monthly_rent);
                    }
                }
             
            }

            //Check for image.
            if (template.find('.comps-image-approach')) {
                var image = '';
                if (comp.property_image_url) {
                    image = $("body").data("cdn-url") + comp.property_image_url;
                    var placeholder = $("body").data("base-url") + 'assets/img/default-placeholder.png';

                    template
                        .find('.comps-image-approach')
                        .attr("src", image);

                    template
                        .find('.image')
                        .css({
                            'background-image': "url(" + image + "), url(" + placeholder + ")"
                        });
                } else {
                    image = $("body").data("base-url") + 'assets/img/default-placeholder.png';

                    template
                        .find('.comps-image-approach')
                        .attr("src", image);

                    template
                        .find('.image')
                        .css({
                            'background-image': "url(" + image + ")"
                        });
                }
            }

            //Sales approach fields
            if (template.find("input[name='evaluation[sales_approach][comps][index][comp_id]']")) {
                template.find("input[name='evaluation[sales_approach][comps][index][comp_id]']").val(comp.id);
            }
            // if (template.find("input[name='evaluation[sales_approach][comps][index][id]']")) {
            //     template.find("input[name='evaluation[sales_approach][comps][index][id]']").val(comp.id);
            // }

            //Cost fields
            // if (template.find("input[name='evaluation[cost_approach][comps][index][id]']")) {
            //     template.find("input[name='evaluation[cost_approach][comps][index][id]']").val(comp.id);
            // }
            
            if (template.find("input[name='evaluation[cost_approach][comps][index][comp_id]']")) {
                template.find("input[name='evaluation[cost_approach][comps][index][comp_id]']").val(comp.id);
            }

            //Multi Family fields
            // if (template.find("input[name='evaluation[multi_family_approach][comps][index][id]']")) {
            //     template.find("input[name='evaluation[multi_family_approach][comps][index][id]']").val(comp.id);
            // }
            if (template.find("input[name='evaluation[multi_family_approach][comps][index][comp_id]']")) {
                template.find("input[name='evaluation[multi_family_approach][comps][index][comp_id]']").val(comp.id);
            }

            //LeaseComps fields
            // if (template.find("input[name='evaluation[lease_comps][comps][index][id]']")) {
            //     template.find("input[name='evaluation[lease_comps][comps][index][id]']").val(comp.id);
            // }

            if (template.find("input[name='evaluation[lease_comps][comps][index][comp_id]']")) {
                template.find("input[name='evaluation[lease_comps][comps][index][comp_id]']").val(comp.id);
            }

            //CAPComps fields
            // if (template.find("input[name='evaluation[cap_comps][comps][index][id]']")) {
            //     template.find("input[name='evaluation[cap_comps][comps][index][id]']").val(comp.id);
            // }
            if (template.find("input[name='evaluation[cap_comps][comps][index][comp_id]']")) {
                template.find("input[name='evaluation[cap_comps][comps][index][comp_id]']").val(comp.id);
            }
            if (template.find("input[name='evaluation[cap_comps][comps][index][cap_rate]']")) {
                template.find("input[name='evaluation[cap_comps][comps][index][cap_rate]']").val(comp.cap_rate);
            }

            //Setting comp id, image and building size
            if (template.find("input[name='single_comp[building_size]']")) {
                template.find("input[name='single_comp[building_size]']").val(size_by_comp_basis);
            }

            //Setting space
            if (template.find("input[name='single_comp[space]']")) {
                template.find("input[name='single_comp[space]']").val(comp.space);
            }

            //Setting lease rate
            if (template.find("input[name='single_comp[lease_rate]']")) {
                template.find("input[name='single_comp[lease_rate]']").val(comp.lease_rate);
            }

            //Setting comp id, image and building size
            if (template.find("input[name='single_comp[price_square_foot]']")) {
                template.find("input[name='single_comp[price_square_foot]']").val(comp.price_square_foot);
            }

            //Setting comp id, image and building size
            if (template.find("input[name='single_comp[land_size]']")) {
                template.find("input[name='single_comp[land_size]']").val(comp.land_size);
            }


            //Setting comp id, image and building size
            if (template.find("input[name='single_comp[land_dimension]']")) {
                template.find("input[name='single_comp[land_dimension]']").val(comp.land_dimension);
            }

            //Setting comp id, image and building size
            if (template.find("input[name='single_comp[price_psf]']")) {
                template.find("input[name='single_comp[price_psf]']").val(comp.price_square_foot);
            }

            if (template.find("input[name='single_comp[sale_price]']")) {
                template.find("input[name='single_comp[sale_price]']").val(comp.sale_price);
            }

            if (template.find("i.view-comp-from-approach")) {
                template.find("i.view-comp-from-approach").attr('data-id', comp.id);
            }

            if (template.find("a.edit-comp-from-approach")) {
                let type = 'sale';
                if (isInArray('cost', segments)) {
                    type = 'lease';
                }
                template.find("a.edit-comp-from-approach").attr('href', $("body").data("base-url")+'comps/overview/'+comp.id+'?redirect='+window.location.pathname+'&evalId='+$('[name="evaluation[id]"]').val()+'&type='+type);
            }

            return template;
        };

        var addNewComp = function (comp,isAddDelete=0,units) {
            var comp_entry_template = $('.comp-entry-template').find('div.col.comps').clone();
            comp_entry_template.find('.dropdown').remove();
            var comps = $('.comp-entry');
            let after_this_adj_div = comp_entry_template.find('.after_this_adj_div');
           
            $('.label-value').each(function() {
                let adj_div = $(".adj_div").clone();
                after_this_adj_div.after(adj_div.removeClass('adj_div'));
            });
            
            comp_entry_template.find('.selector').first().addClass('break1');
            let child = ($("#comp_adjustment_mode").val()=="Dollar") ? comp_entry_template.find('.dollar-input') : comp_entry_template.find('.percentage-dropdown')  ;
            let apprach_name = '';
            if(location.pathname.indexOf('/sales') !== -1){
                apprach_name = 'sales_approach';
            }else if(location.pathname.indexOf('/leaseComps') !== -1){
                apprach_name = 'lease_comps';
            }else if(location.pathname.indexOf('/cost') !== -1){
                apprach_name = 'cost_approach';
            }else if(location.pathname.indexOf('/multiFamilyComps') !== -1){
                apprach_name = 'multi_family_approach';
            }

            let counter = 1;
            $(child).each(function() {
                $(this).closest('.selector').addClass('counter-' + counter);
                const name = $('.counter-label-'+counter).attr('data-name');
                if($("#comp_adjustment_mode").val()=="Dollar"){
                    $(this).closest('.selector').addClass('counter-' + counter);
                    $(this).find('input.select-dollar').attr('name','evaluation['+apprach_name+'][comps][index]['+name+']').attr('id','evaluation['+apprach_name+'][comps][index]['+name+']');
                }else{
                    $(this).find('select').material_select();
                    $(this).find('select').attr('data',name+'_custom');
                    $(this).find('select').attr('name','evaluation['+apprach_name+'][comps][index]['+name+']');
                    $(this).find('input.custom_field').addClass(name+'_custom');
                    $(this).find('input.custom_field').attr('name','evaluation['+apprach_name+'][comps][index]['+name+'_custom]');
                }
                counter++;
            });
            comp_entry_template.addClass('comp-entry');

            comp_entry_template = setCompFields(comp_entry_template, comp,units);
            if(location.pathname.indexOf('/multiFamilyComps') !== -1){
                let u_id = 0;
                    units.forEach((value, index, self) => {
                        if(comp.id === self[index]['id']){
                            u_id  = self[index]['unit_id'];
                        }
                    });
                    $(comp_entry_template).attr('data-id', comp.id+u_id);
            }else{       
                $(comp_entry_template).attr('data-id', comp.id);
            }
            //Set to display none, so later the smooth show transition can be used.
            comp_entry_template.css('display', 'none');

            if (comps.length !== 0 && comps.length < 3) {
                comps.last().after(comp_entry_template);
            } else if (comps.length === 3) {
                $('.comp-add').addClass('hide');
                comps.last().after(comp_entry_template);
            } else {
                $('.comp-current').after(comp_entry_template);
            }

            comp_entry_template.show('slow');

            setCompsColors();
            initializeMasks();

            if (isInArray('sales', segments)) {
                ApproachCalculator.calculateSalesApproach(isAddDelete);
                initializeSpecificDropdowns(comp_entry_template.find('select.sales-comps-field'), ApproachCalculator.calculateSalesApproach);
                initializeSpecificCustomInput(comp_entry_template.find('input.sales-comps-field'), ApproachCalculator.calculateSalesApproach);
                initializeSpecificInput(comp_entry_template.find('input.select-dollar'), ApproachCalculator.calculateSalesApproach);
                initializeSpecificInput(comp_entry_template.find('.percentage-dropdown-weighting').find('input'), ApproachCalculator.calculateSalesApproach);
            } else if (isInArray('cost', segments)) {
                ApproachCalculator.calculateCostApproach(isAddDelete);
                initializeSpecificDropdowns(comp_entry_template.find('select.cost-comps-field'), ApproachCalculator.calculateCostApproach);
                initializeSpecificCustomInput(comp_entry_template.find('input.cost-comps-field'), ApproachCalculator.calculateCostApproach);
                initializeSpecificInput(comp_entry_template.find('input.select-dollar'), ApproachCalculator.calculateCostApproach);
                initializeSpecificInput(comp_entry_template.find('.percentage-dropdown-weighting').find('input'), ApproachCalculator.calculateCostApproach);
            }else if (isInArray('leaseComps', segments)) {
                ApproachCalculator.calculateLeaseComps(isAddDelete);
                initializeSpecificDropdowns(comp_entry_template.find('select.sales-comps-field'), ApproachCalculator.calculateLeaseComps);
                initializeSpecificCustomInput(comp_entry_template.find('input.sales-comps-field'), ApproachCalculator.calculateLeaseComps);
                initializeSpecificInput(comp_entry_template.find('input.select-dollar'), ApproachCalculator.calculateLeaseComps);
                initializeSpecificInput(comp_entry_template.find('.percentage-dropdown-weighting').find('input'), ApproachCalculator.calculateLeaseComps);
            }else if (isInArray('capComps', segments)) {
                ApproachCalculator.calculateCapComps(isAddDelete);
                initializeSpecificInput(comp_entry_template.find('.percentage-dropdown-weighting').find('input'), ApproachCalculator.calculateCapComps);
            }else if (isInArray('multiFamilyComps', segments)) {
                ApproachCalculator.calculateMultiFamilyApproach(isAddDelete);
                initializeSpecificDropdowns(comp_entry_template.find('select.sales-comps-field'), ApproachCalculator.calculateMultiFamilyApproach);
                initializeSpecificCustomInput(comp_entry_template.find('input.sales-comps-field'), ApproachCalculator.calculateMultiFamilyApproach);
                initializeSpecificInput(comp_entry_template.find('input.select-dollar'), ApproachCalculator.calculateMultiFamilyApproach);
                initializeSpecificInput(comp_entry_template.find('.percentage-dropdown-weighting').find('input'), ApproachCalculator.calculateMultiFamilyApproach);
                ViewManager.save()
            }
            initOrders();
        };

        $(document).on('click', '.add-label', function () {
            let adjustment_labels = $('.adjustmentlabel');
            let new_label_input = adjustment_labels.last().clone();
            let btn_value = $(this).attr('value');
            let inc_btn_value = parseInt(btn_value)+1;
            let apprach_name = '';
            if (location.pathname.indexOf('/sales') !== -1){
                apprach_name = 'sales_approach';
            }else if(location.pathname.indexOf('/leaseComps') !== -1){
                apprach_name = 'lease_comps';
            }else if(location.pathname.indexOf('/cost') !== -1){
                apprach_name = 'cost_approach';
            }else if(location.pathname.indexOf('/multiFamilyComps') !== -1){
                apprach_name = 'multi_family_approach';
            }

            new_label_input.find('input').removeClass('counter-label-'+btn_value).addClass('counter-label-'+inc_btn_value);
            new_label_input.find('.delete-label').attr('value',inc_btn_value);
            new_label_input.find('input').attr('name', 'evaluation['+apprach_name+'][subject_property_adjustments]['+inc_btn_value+']').attr('value','');
            new_label_input.find('.add-label').attr('value',inc_btn_value); 
            new_label_input.find('input').val('');
            new_label_input.find('input').attr('data-name',inc_btn_value);
            adjustment_labels.last().after(new_label_input);
            if($('.adjustmentlabel').length > 1)
            {
               $('.delete-label').removeClass('hide');
            }
            let break_row =  $('.breakdowns').last().clone().removeClass('break1');
            $('.evaluation-approach-property').find('.breakdowns').last().after(break_row);

            $('.comp-entry').each (function () {
                let drop_row =  $('.adj_div').clone().removeClass('adj_div').removeClass('counter-'+btn_value).addClass('counter-'+inc_btn_value);
                $(this).find('.costup').before(drop_row);
                $(this).find('.notes_div').before(drop_row);
                if ($("#comp_adjustment_mode").val() == "Dollar") {
                    drop_row.find('.dollar-input').closest('.counter-'+inc_btn_value).find('input.select-dollar').attr('name', 'evaluation['+apprach_name+'][comps][index][' + inc_btn_value + ']');
                    drop_row.find('.dollar-input').closest('.counter-'+inc_btn_value).find('input.select-dollar').attr('id','evaluation['+apprach_name+'][comps][index]['+inc_btn_value+']');
                } else {
                    drop_row.find('select').material_select();
                    drop_row.find('select').attr('name', 'evaluation['+apprach_name+'][comps][index]['+inc_btn_value+']');
                    drop_row.find('select').attr('data', inc_btn_value+'_custom');
                    drop_row.find('input.custom_field').attr('name', 'evaluation['+apprach_name+'][comps][index]['+inc_btn_value+'_custom]');
                    drop_row.find('input.custom_field').addClass(inc_btn_value+'_custom');
                }
                
                if (location.pathname.indexOf('/sales') !== -1){
                    initializeSpecificDropdowns(drop_row.find('select.sales-comps-field'), ApproachCalculator.calculateSalesApproach);
                    initializeSpecificCustomInput(drop_row.find('input.sales-comps-field'), ApproachCalculator.calculateSalesApproach);
                    initializeSpecificInput(drop_row.find('input.select-dollar'), ApproachCalculator.calculateSalesApproach);
                }else if(location.pathname.indexOf('/leaseComps') !== -1){
                    initializeSpecificDropdowns(drop_row.find('select.sales-comps-field'), ApproachCalculator.calculateLeaseComps);
                    initializeSpecificCustomInput(drop_row.find('input.sales-comps-field'), ApproachCalculator.calculateLeaseComps);
                    initializeSpecificInput(drop_row.find('input.select-dollar'), ApproachCalculator.calculateLeaseComps);   
                }else if(location.pathname.indexOf('/cost') !== -1){
                    initializeSpecificDropdowns(drop_row.find('select.cost-comps-field'), ApproachCalculator.calculateCostApproach);
                    initializeSpecificCustomInput(drop_row.find('input.cost-comps-field'), ApproachCalculator.calculateCostApproach);
                    initializeSpecificInput(drop_row.find('input.select-dollar'), ApproachCalculator.calculateCostApproach);
                }else if(location.pathname.indexOf('/multiFamilyComps') !== -1){
                    initializeSpecificDropdowns(drop_row.find('select.sales-comps-field'), ApproachCalculator.calculateMultiFamilyApproach);
                    initializeSpecificCustomInput(drop_row.find('input.sales-comps-field'), ApproachCalculator.calculateMultiFamilyApproach);
                    initializeSpecificInput(drop_row.find('input.select-dollar'), ApproachCalculator.calculateMultiFamilyApproach);   
                } 
                drop_row.find('input.select-dollar').on("keyup", function (e) {
                    maskCurrency(e,this);
                });
                drop_row.find('.postmask-percentage-field').on("keyup", function (e) {
                    maskPercentage(e,this);
                });
            });
            $(this).addClass('hide').attr('disabled',true);
            if($('.adjustmentlabel').length >= 8){
                $('.add-label').last().addClass('hide')
                return false;
            }
            $('.add-label').last().removeClass('hide');
        });
        
        $(document).on('click', '.delete-label', function () {
            let btn_value = $(this).attr('value');
            $(this).closest('.adjustmentlabel').remove();
            $('.counter-'+btn_value).remove();
            if($('.adjustmentlabel').length == 1)
            {
                $('.delete-label').addClass('hide');
            }
            $('.add-label').last().removeClass('hide');
            $('.evaluation-approach-property').find('.breakdowns').last().remove();
            $('.adjustmentlabel').first().addClass('break1');
            $('.breakdowns').first().addClass('break1');
            $('.comp-entry').each (function () {
                $(this).find('.selector').first().addClass('break1');
            });
            updateLabelsClass();
            updateCompsInputs();
            if (location.pathname.indexOf('/sales') !== -1){
                ApproachCalculator.calculateSalesApproach();
            }else if(location.pathname.indexOf('/leaseComps') !== -1){
                ApproachCalculator.calculateLeaseComps();    
            }else if(location.pathname.indexOf('/cost') !== -1){
                ApproachCalculator.calculateCostApproach();
            }else if(location.pathname.indexOf('/multiFamilyComps') !== -1){
                ApproachCalculator.calculateMultiFamilyApproach();
            }
        });
        
        var updateExistingComp = function (comp,isAddDelete=0,units) {
            var comp_entry_template;
            $('.comp-entry').each(function() { 
                if($(this).attr('data-id')==comp.id)
                {
                    comp_entry_template = $(this);
                }
            });
            comp_entry_template.addClass('comp-entry');
            comp_entry_template = setCompFields(comp_entry_template, comp,units);
            if(location.pathname.indexOf('/multiFamilyComps') !== -1){
                let u_id = 0;
                units.forEach((value, index, self) => {
                    if(comp.id === self[index]['id']){
                        u_id  = self[index]['unit_id'];
                    }
                });
                $(comp_entry_template).attr('data-id', comp.id+u_id);
            }else{       
                $(comp_entry_template).attr('data-id', comp.id);
            }
            comp_entry_template.css('display', 'none');
            comp_entry_template.show('slow');
            setCompsColors();
            initializeMasks();
            if (isInArray('sales', segments)) {
                ApproachCalculator.calculateSalesApproach(isAddDelete);
            } else if (isInArray('cost', segments)) {
                ApproachCalculator.calculateCostApproach(isAddDelete);
            } else if (isInArray('leaseComps', segments)) {
                ApproachCalculator.calculateLeaseComps(isAddDelete);
            } else if (isInArray('capComps', segments)) {
                ApproachCalculator.calculateCapComps(isAddDelete);
            } else if (isInArray('multiFamilyComps', segments)) {
                ApproachCalculator.calculateMultiFamilyApproach(isAddDelete);
            }
            initOrders();
            ViewManager.save();
        };

        var updateSelectLabel = function (e) {
            var label = "";
            if($("#comp_adjustment_mode").val()=="Dollar"){
                // label = $(this).parent().parent().parent().find('.dollar-label').find('label');
                label = $(this).closest('.selector').find('.dollar-label').find('label');
            }else{
                label = $(this).parent().parent().parent().find('.percentage-label').find('label');
            }
            var value = $(this).val();
            if($(this).hasClass('custom_field')){
                if(e.keyCode==8 || parseFloat(nStr)>100)
                {
                    value = value.slice(0,-1);
                }
            }
            if(value == 'Type My Own'){
                value = $(this).parent().parent().find('.'+$(this).attr('data')).attr('value');
                $(this).parent().parent().append("<a class='convert_to_dropdown' style='position: absolute; margin-left:-10px;' onclick = 'convert_to_dropdown(this)'><i class='tiny material-icons'>autorenew</i></a>");
                $(this).parent().parent().find('.'+$(this).attr('data')).removeClass('hide');
                $(this).parent().addClass('hide');
            }else{
                var sign="";
                if( $(this).val().indexOf("-") != -1){
                    sign="-";
                }
                value = sign + value.replace(/[^\d.]/g, '');
                $(this).parent().parent().find('.'+$(this).attr('data')).addClass('hide');
                $(this).parent().removeClass('hide');
            }
            if (label !== null && label !== 'undefined' && value !== null && value !== 'undefined') {
                if (parseFloat(value) < 0) {
                    label.text('Superior');
                    label.css("color", "#49bf6d");
                    label.css("font-weight", "bold");
                } else if (parseFloat(value) > 0) {
                    label.text('Inferior');
                    label.css("color", "#f55454" +
                        "");
                        label.css("font-weight", "bold");
                    } else {
                    label.text('Equal');
                    label.css("color", "#9e9e9e");
                    label.css("font-weight", "normal");
                }
            }
        };

        var initializeSpecificDropdowns = function (selects, callback) {
            var count = selects.length;
            for (var i = 0; i < count; i++) {
                if (selects[i]) {
                    $(selects[i]).material_select();
                    $(selects[i]).change(_.debounce(callback, 500));
                    $(selects[i]).change(updateSelectLabel);
                    
                    var label = $(selects[i]).parent().parent().parent().find('.percentage-label').find('label');
                    var value = $(selects[i]).val();

                    if (parseFloat(value) < 0) {
                        label.text('Superior');
                        label.css("color", "#49bf6d");
                        label.css("font-weight", "bold");
                    } else if (parseFloat(value) > 0) {
                        label.text('Inferior');
                        label.css("color", "#f55454" +
                            "");
                        label.css("font-weight", "bold");
                    } else {
                        label.text('Equal');
                        label.css("color", "#9e9e9e");
                        label.css("font-weight", "normal");
                    }
                }
            }
        };

        var initializeSpecificDollarInput = function (selects, callback) {
            var count = selects.length;
            for (var i = 0; i < count; i++) {
                if (selects[i]) {
                    $(selects[i]).change(_.debounce(callback, 500));
                    $(selects[i]).change(updateSelectLabel);

                    // var label = $(selects[i]).parent().parent().parent().find('.dollar-label').find('label');
                    // var value = $(selects[i]).val();
                    let label = $(selects[i]).closest('.selector').find('.dollar-label').find('label');
                    let value = $(selects[i]).val().replace(/,/g, '').replace('$', '');

                    if (parseFloat(value) < 0) {
                        label.text('Superior');
                        label.css("color", "#49bf6d");
                        label.css("font-weight", "bold");
                    } else if (parseFloat(value) > 0) {
                        label.text('Inferior');
                        label.css("color", "#f55454" +
                            "");
                        label.css("font-weight", "bold");
                    } else {
                        label.text('Equal');
                        label.css("color", "#9e9e9e");
                        label.css("font-weight", "normal");
                    }
                }
            }
        };

        var initializeSpecificInput = function (inputs, callback) {
            var count = inputs.length;
            for (var i = 0; i < count; i++) {
                if (inputs[i]) {
                    $(inputs[i]).keyup(_.debounce(callback, 500));
                }
            }
            if($("#comp_adjustment_mode").val()=="Dollar"){
                initializeSpecificDollarInput(inputs, callback);
            }
        };

        var initializeSpecificCustomInput = function (inputs, callback) {
            var count = inputs.length;
            for (var i = 0; i < count; i++) {
                if (inputs[i]) {
                    $(inputs[i]).keyup(_.debounce(callback, 500));
                    $(inputs[i]).keyup(updateSelectLabel);

                    var label = $(inputs[i]).parent().parent().parent().find('.percentage-label').find('label');
                    var value = $(inputs[i]).val();

                    if($(inputs[i]).parent().children().children('select').val() === 'Type My Own'){
                        if (parseFloat(value) < 0) {
                            label.text('Superior');
                            label.css("color", "#49bf6d");
                            label.css("font-weight", "bold");
                        } else if (parseFloat(value) > 0) {
                            label.text('Inferior');
                            label.css("color", "#f55454" + "");
                            label.css("font-weight", "bold");
                        } else {
                            label.text('Equal');
                            label.css("color", "#9e9e9e");
                            label.css("font-weight", "normal");
                        }
                    }
                }
            }
        };

        var setCompInputs = function (template, comp_fields, approach, comp) {
            for (var key in comp_fields) {
                var field = template.find("[name='evaluation[" + approach + "][comps][index][" + key + "]']");
                var field_custom = template.find("[name='evaluation[" + approach + "][comps][index][" + key + "_custom]']");

                if (field) {
                    if (comp_fields.hasOwnProperty(key)) {
                        if (comp_fields[key]) {
                            if(comp_fields[key] == 'Type My Own'){
                                field_custom.val(comp_fields[key+'_custom']).trigger('change');
                                field_custom.removeClass('hide');
                                field_custom.after("<a class='convert_to_dropdown' style='position: absolute; margin-left:-10px;' onclick = 'convert_to_dropdown(this)'><i class='tiny material-icons'>autorenew</i></a>");
                                field.addClass('hide');
                                field.val(comp_fields[key]).trigger('change');
                            }
                            else{
                                if(key == 'cap_rate' && comp[key] != comp_fields[key])
                                    comp_fields[key] = comp[key];
                                field.val(comp_fields[key]).trigger('change');
                            }
                            var text = 'Click to edit adjustment notes';
                            if (location.pathname.indexOf('/leaseComps') !== -1){
                                text = 'Click to edit property notes';
                            }else if (location.pathname.indexOf('/capComps') !== -1){
                                text = 'Click to edit weighting notes';
                            }
                            if((key == 'adjustment_note' && comp_fields.adjustment_note) || (key == 'weighting_note' && comp_fields.weighting_note))
                            {
                                template.find('.adjustment_input_text').html(text);
                                template.find('.adjustment_link').addClass('hide');
                                template.find('.adjustment_input_text').removeClass('hide');
                            }else if((key == 'adjustment_note' && comp_fields.adjustment_note == "") || (key == 'weighting_note' && comp_fields.weighting_note == "")){
                                template.find('.adjustment_link').removeClass('hide');
                                template.find('.adjustment_input_text').addClass('hide');
                            }
                        }
                    }
                }
            }

            return template;
        };

        var loadExistingComp = function (comp_fields, approach) {
            let id = comp_fields.comp_id;
            return $.ajax({
                type: "GET",
                url: $("body").data("base-url") + "comps/get",
                data: { id: id, 'normalize': true },
                success: function (responseText) {
                    var comp = JSON.parse(responseText);
                    if (comp !== 'failure') {
                        let units=[];
                        if(comp_fields.property_unit){
                            units.push({id: id, unit_id: comp_fields.property_unit_id});
                        }
                        var comp_entry_template = $('.comp-entry-template').find('div.col.comps').clone();
                        comp_entry_template.addClass('comp-entry');
                        comp_entry_template.css('display', 'none');
                        if(location.pathname.indexOf('/multiFamilyComps') !== -1){
                            let u_id = 0;
                            units.forEach((value, index, self) => {
                                if(comp.id === self[index]['id']){
                                    u_id  = self[index]['unit_id'];
                                }
                            });
                            $(comp_entry_template).attr('data-id', comp.id+u_id);
                        }else{       
                            $(comp_entry_template).attr('data-id', comp.id);
                        }
                        comp_entry_template = setCompFields(comp_entry_template, comp, units);
                        comp_entry_template = setCompInputs(comp_entry_template, comp_fields, approach, comp);

                        compsInApproaches.push({ order: parseInt(comp_fields.order), template: comp_entry_template[0] });
                    }
                },
                failure: function (errMsg) {
                    console.error("error:" + errMsg);
                }
            });
        };

        var loadCompsInSales = function () {
            var id = $('input[name="evaluation_sales_approaches[id]"]').val();
            var deferreds = [];
            compsInApproaches = [];

            $.ajax({
                type: 'GET',
                url: $("body").data("base-url") + "approaches/get/" + id,
                data: {
                    approach: 'sales'
                },
                success: function (responseText) {
                    if(responseText!=="" && responseText!=="null")
                    {
                        var response = JSON.parse(responseText);
                        if (response != undefined && response.comps) {
                            for (var comp in response.comps) {
                                if (response.comps.hasOwnProperty(comp)) {
                                    deferreds.push(loadExistingComp(response.comps[comp], 'sales_approach'));
                                }
                            }
                        }else{
                            for (var comp in response) {
                                deferreds.push(loadExistingComp(response[comp], 'sales_approach'));
                            }
                        }
                    }
                }
            }).done(function () {
                $.when.apply($, deferreds).then(function () {
                    initComps();
                    initializeMasks();
                    initOrders();
                    ApproachCalculator.calculateSalesApproach();
                });
            });
        };

        var compare = function (a, b) {
            var genreA = a.order;
            var genreB = b.order;

            var comparison = 0;
            if (genreA > genreB) {
                comparison = 1;
            } else if (genreA < genreB) {
                comparison = -1;
            }
            return comparison;
        };

        var initComps = function () {
            compsInApproaches = compsInApproaches.sort(compare);

            for (var comp in compsInApproaches) {
                if (compsInApproaches.hasOwnProperty(comp)) {
                    var comps = $('.comp-entry');

                    var comp_entry_template = $(compsInApproaches[comp].template);

                    if (comps.length !== 0 && comps.length < 3) {
                        comps.last().after(comp_entry_template);
                    } else if (comps.length === 3) {
                        $('.comp-add').addClass('hide');
                        comps.last().after(comp_entry_template);
                    } else {
                        $('.comp-current').after(comp_entry_template);
                    }

                    comp_entry_template.show('slow');

                    if (isInArray('sales', segments)) {
                        initializeSpecificDropdowns(comp_entry_template.find('select.sales-comps-field'), ApproachCalculator.calculateSalesApproach);
                        initializeSpecificCustomInput(comp_entry_template.find('input.sales-comps-field'), ApproachCalculator.calculateSalesApproach);
                        initializeSpecificInput(comp_entry_template.find('input.select-dollar'), ApproachCalculator.calculateSalesApproach);
                        initializeSpecificInput(comp_entry_template.find('.percentage-dropdown-weighting').find('input'), ApproachCalculator.calculateSalesApproach);
                    } else if (isInArray('cost', segments)) {
                        initializeSpecificDropdowns(comp_entry_template.find('select.cost-comps-field'), ApproachCalculator.calculateCostApproach);
                        initializeSpecificCustomInput(comp_entry_template.find('input.cost-comps-field'), ApproachCalculator.calculateCostApproach);
                        initializeSpecificInput(comp_entry_template.find('input.select-dollar'), ApproachCalculator.calculateCostApproach);
                        initializeSpecificInput(comp_entry_template.find('.percentage-dropdown-weighting').find('input'), ApproachCalculator.calculateCostApproach);
                    } else if (isInArray('leaseComps', segments)) {
                        initializeSpecificDropdowns(comp_entry_template.find('select.sales-comps-field'), ApproachCalculator.calculateLeaseComps);
                        initializeSpecificCustomInput(comp_entry_template.find('input.sales-comps-field'), ApproachCalculator.calculateLeaseComps);
                        initializeSpecificInput(comp_entry_template.find('input.select-dollar'), ApproachCalculator.calculateLeaseComps);
                        initializeSpecificInput(comp_entry_template.find('.percentage-dropdown-weighting').find('input'), ApproachCalculator.calculateLeaseComps);
                    } else if (isInArray('capComps', segments)) {
                        initializeSpecificInput(comp_entry_template.find('.percentage-dropdown-weighting').find('input'), ApproachCalculator.calculateCapComps);
                    }else if (isInArray('multiFamilyComps', segments)) {
                        initializeSpecificDropdowns(comp_entry_template.find('select.sales-comps-field'), ApproachCalculator.calculateMultiFamilyApproach);
                        initializeSpecificCustomInput(comp_entry_template.find('input.sales-comps-field'), ApproachCalculator.calculateMultiFamilyApproach);
                        initializeSpecificInput(comp_entry_template.find('input.select-dollar'), ApproachCalculator.calculateMultiFamilyApproach);
                        initializeSpecificInput(comp_entry_template.find('.percentage-dropdown-weighting').find('input'), ApproachCalculator.calculateMultiFamilyApproach);
                    }

                    setCompsColors();
                }
            }
        };

        var initOrders = function () {
            $('.comp-entry').find('[name="evaluation[sales_approach][comps][index][order]"]').each(function (i, e) {
                $(e).val(i + 1);
            });

            $('.comp-entry').find('[name="evaluation[cost_approach][comps][index][order]"]').each(function (i, e) {
                $(e).val(i + 1);
            });
            $('.comp-entry').find('[name="evaluation[lease_comps][comps][index][order]"]').each(function (i, e) {
                $(e).val(i + 1);
            });
            $('.comp-entry').find('[name="evaluation[cap_comps][comps][index][order]"]').each(function (i, e) {
                $(e).val(i + 1);
            });

            $('.comp-entry').find('[name="evaluation[multi_family_approach][comps][index][order]"]').each(function (i, e) {
                $(e).val(i + 1);
            });
            
        };

        var loadCompsInCost = function () {
            var id = $('input[name="evaluation_cost_approaches[id]"]').val();
            var deferreds = [];
            compsInApproaches = [];

            $.ajax({
                type: 'GET',
                url: $("body").data("base-url") + "approaches/get/" + id,
                data: {
                    approach: 'cost'
                },
                success: function (responseText) {
                    if(responseText!=="" && responseText!=="null")
                    {
                        var response = JSON.parse(responseText);
                        if (response != undefined && response.comps) {
                            for (var comp in response.comps) {
                                if (response.comps.hasOwnProperty(comp)) {
                                    deferreds.push(loadExistingComp(response.comps[comp], 'cost_approach'));
                                }
                            }
                        }else{
                            for (var comp in response) {
                                deferreds.push(loadExistingComp(response[comp], 'cost_approach'));
                            }
                        }
                    }
                }
            }).done(function () {
                $.when.apply($, deferreds).then(function () {
                    initComps();
                    initializeMasks();
                    initOrders();
                    ApproachCalculator.calculateCostApproach();
                });
            });
        };

        var removeCompFromApproach = function (event) {
            if (event.currentTarget) {
                var step = location.pathname.split("/");

                var $this = $(event.currentTarget);

                $this.closest('.comp-entry').remove();

                var comps = $('.comp-entry');

                if (comps.length < 4) {
                    $('.comp-add').removeClass('hide');
                }

                if (isInArray('sales', step)) {
                    setCompsColors();
                    ApproachCalculator.calculateSalesApproach(1);
                }else if (isInArray('leaseComps', step)) {
                    setCompsColors();
                    ApproachCalculator.calculateLeaseComps(1);                               
                    setTimeout( function() { 
                        ViewManager.save();
                    },500);
                }else if (isInArray('capComps', step)) {
                    setCompsColors();
                    ApproachCalculator.calculateCapComps(1);
                    setTimeout( function() { 
                        ViewManager.save();
                    },500);
                } else if (isInArray('cost', step) || isInArray('cost-improvement', step)) {
                    setCompsColors();
                    ApproachCalculator.calculateCostApproach(1);
                }else if (isInArray('multiFamilyComps', step)) {
                    setCompsColors();
                        ApproachCalculator.calculateMultiFamilyApproach();                           
                    setTimeout( function() { 
                        ViewManager.save();
                    },500);
                }

                initOrders();
                dataToSave = true;
            }
        };

        var setCompHandling = function () {
            //Sales Comparison Approach Controller
            $(document).on('click', '.remove-comp-from-approach', function (event) {
                deleteConfirm(removeCompFromApproach, event);
            });

            $(document).on('click', '.add-new-comp', function () {
                $("#select-comp").modal({dismissible:false});
                $('#select-comp').modal('open');
            });

            $(document).on('click', '#filterCriteria', function () {
                $("#modal-filter-criteria").modal({dismissible:false});
                $('#modal-filter-criteria').modal('open');
            });

            $(document).on('click', '.view-comp-from-approach', function () {
                if ($(this).data('entity') === 'evaluation') {
                    openForm($(this).data('id'));
                    $('.button-evaluation-collapse').sideNav('show');
                } else {
                    CompsController.openForm($(this).data('id'));
                    $('.button-comps-collapse').sideNav('show');
                }
            });
            $(document).on('click', '.selectCompsBtn', function () {
                showAdvanceLoading();
                $(".selectCompsBtn").attr('disabled',true);
                setTimeout( function() { 
                    selectComps();
                    $(".selectCompsBtn").attr('disabled',false);
                    hideAdvanceLoading();
                },200);
            });
            $(document).on('click', '.adjustedSearch', function () {
                $('.advance_search_btn').addClass('hide');
                $('.advance_filter_form').removeClass('hide');
                $('.get_comps').removeClass('hide');
                $('#comp_tbl_wrap').hide();
            });
            $(document).on('click', '.get_comps', function () {
                loadListings();
            });
            $("#results_format").on('change', function() {
                if(!$('.advance_search_btn').hasClass('hide')){
                    document.querySelector('.get_comps').click();
                }
            });

            initAutoCompleteWithAjaxAndId({
                inputId: 'autocomplete-comps',
                ajaxUrl: 'comps/search',
                onSelect: onSelectComp,
                evaluation_id: $("input[name='evaluation[id]']").val(),
                limit: 6
            });
        };

        var loadListings = function () {
            map_comps_ids = [];
            map_comps_unit_ids = [];
            EvaluationsCommons.clean();
            $('.advance_search_btn').removeClass('hide');
            $('.advance_filter_form').addClass('hide');
            $('.get_comps').addClass('hide');
            var formValues= $("#form_modal").serialize(); 
            $.ajax({
                type: "POST",
                url: $("body").data("base-url") + "evaluations/get_comps",
                data: formValues,
                beforeSend: function (xhr) {
                    showAdvanceLoading();
                },
                success: function (responseText) {
                    EvaluationsCommons.resetMarkers();
                    var dataTable = $("#comps-modal-table").DataTable();
                    dataTable.destroy();
                    $("#comps-modal-table").html();
                    var comp = JSON.parse(responseText);
                    $("#comp_tbl_wrap").show();
                    if (comp.response == "") {
                        $(".selectCompsBtn").hide();
                    } else {
                        $(".selectCompsBtn").show();
                    }
                    if ($("#results_format").is(":checked")) {
                        $("#comps-modal-table").addClass("hide");
                        if (comp.comps_data == "No record found") {
                            $("#listings-map").addClass("hide");
                            $("#response_div").removeClass("hide");
                        } else {
                            $("#response_div").addClass("hide");
                            $("#listings-map").removeClass("hide");
                        }
                    } else {
                        $("#comps-modal-table").removeClass("hide");
                        $("#listings-map").addClass("hide");
                        $("#response_div").addClass("hide");
                    }
                    $("#comps-modal-table").html(comp.response);
                    const table  = $("#comps-modal-table").DataTable({
                        searching: false,
                        lengthChange: false,
                        pagination: false,
                        order: [[8, "desc"]],
                        paginate: false,
                    });
                    // Removing default style as it is causing table not to expand full width 
                    const headers = table.columns().header();
                    headers.each(function(th) {
                        $(th).removeAttr("style");
                    });
                    
                    $(comp.comps_data).each(function (index, instance) {
                        EvaluationsCommons.buildListing(instance);
                    });
                    EvaluationsCommons.fitBounds();
                    EvaluationsCommons.checkMap();
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    if (jqXHR.status == 500) {
                        Materialize.toast(errorThrown,1000);
                    } else {
                        Materialize.toast('Unexpected error.',1000);
                    }
                    hideAdvanceLoading();
                }
            }).done(function () {
                hideAdvanceLoading();
            });
        };

        var loadSideNav = function () {
            var buttonSettings = {
                menuWidth: '50%',
                edge: 'left',
                closeOnClick: false
            };

            $('.button-evaluation-collapse').sideNav(buttonSettings);

            buttonSettings.onClose = function (el) {
                CompsController.resetForm();
            };
            $('.button-comps-collapse').sideNav(buttonSettings);
        };

        var createNewComp = function () {
            $('#select-comp').modal('close');
            clearFilters();
            CompsController.openForm(null, true);
            $('.button-comps-collapse').sideNav('show');
        };

        var setMultiFamilyApproachFields = function () {
            setCompHandling();
            loadMultiComps();
            if(document.getElementById("save-evaluation"))
                document.getElementById("save-evaluation").addEventListener("click", saveComp);
            if($("#create-new-comp").length){
                document.getElementById("create-new-comp").addEventListener("click", createNewComp);
                loadSideNav();
                CompsController.loadSideNav();
            }
        };
        var setSalesApproachFields = function () {
            setCompHandling();
            loadCompsInSales();
            if(document.getElementById("save-evaluation"))
                document.getElementById("save-evaluation").addEventListener("click", saveComp);
            if($("#create-new-comp").length){
                document.getElementById("create-new-comp").addEventListener("click", createNewComp);
                loadSideNav();
                CompsController.loadSideNav();
            }
        };

        var setCostApproachFields = function () {
            setCompHandling();
            loadCompsInCost();
            if(document.getElementById("save-evaluation"))
                document.getElementById("save-evaluation").addEventListener("click", saveComp);
            if($("#create-new-comp").length){
                document.getElementById("create-new-comp").addEventListener("click", createNewComp);
                loadSideNav();
                CompsController.loadSideNav();
            }
        };

        var loadMultiComps = function () {
            var id = $('input[name="evaluation_multi_family_approach[id]"]').val();
            var deferreds = [];
            compsInApproaches = [];

            $.ajax({
                type: 'GET',
                url: $("body").data("base-url") + "approaches/get/" + id,
                data: {
                    approach: 'multiFamilyApproach'
                },
                success: function (responseText) {
                    if(responseText!=="" && responseText!=="null")
                    {
                        var response = JSON.parse(responseText);
                        if (response != undefined && response.comps) {
                            for (var comp in response.comps) {
                                if (response.comps.hasOwnProperty(comp)) {
                                    deferreds.push(loadExistingComp(response.comps[comp], 'multi_family_approach'));
                                }
                            }
                        }else{
                            for (var comp in response) {
                                deferreds.push(loadExistingComp(response[comp], 'multi_family_approach'));
                            }
                        }
                    }
                }
            }).done(function () {
                $.when.apply($, deferreds).then(function () {
                    initComps();
                    initializeMasks();
                    initOrders();
                    ApproachCalculator.calculateMultiFamilyApproach();
                });
            });
        };
        var loadCompsInLeaseComps = function () {
            var id = $('input[name="evaluation_lease_approaches[id]"]').val();
            var deferreds = [];
            compsInApproaches = [];

            $.ajax({
                type: 'GET',
                url: $("body").data("base-url") + "approaches/get/" + id,
                data: {
                    approach: 'leaseComps'
                },
                success: function (responseText) {
                    if(responseText!==""  && responseText !=="null")
                    {
                        var response = JSON.parse(responseText);
    
                        if (response.comps) {
                            for (var comp in response.comps) {
                                if (response.comps.hasOwnProperty(comp)) {
                                    deferreds.push(loadExistingComp(response.comps[comp], 'lease_comps'));
                                }
                            }
                        }else{
                            for (var comp in response) {
                                deferreds.push(loadExistingComp(response[comp], 'lease_comps'));
                            }
                        }
                    }
                }
            }).done(function () {
                $.when.apply($, deferreds).then(function () {
                    initComps();
                    initializeMasks();
                    initOrders();
                    ApproachCalculator.calculateLeaseComps();
                });
            });
        };

        var setLeaseCompsFields = function () {
            setCompHandling();
            loadCompsInLeaseComps();
            if(document.getElementById("save-evaluation"))
                document.getElementById("save-evaluation").addEventListener("click", saveComp);
            if($("#create-new-comp").length){
                document.getElementById("create-new-comp").addEventListener("click", createNewComp);
                loadSideNav();
                CompsController.loadSideNav();
            }
        };

        var loadCompsInCAPComps = function () {
            var id = $('input[name="evaluation_cap_approaches[id]"]').val();
            var deferreds = [];
            compsInApproaches = [];
            $.ajax({
                type: 'GET',
                url: $("body").data("base-url") + "approaches/get/" + id,
                data: {
                    approach: 'capComps'
                },
                success: function (responseText) {
                    if(responseText!=="" && responseText!=="null")
                    {
                        var response = JSON.parse(responseText);
                        if (response != undefined && response.comps) {
                            for (var comp in response.comps) {
                                if (response.comps.hasOwnProperty(comp)) {
                                    deferreds.push(loadExistingComp(response.comps[comp], 'cap_comps'));
                                }
                            }
                        }else{
                            for (var comp in response) {
                                deferreds.push(loadExistingComp(response[comp], 'cap_comps'));
                            }
                        }
                    }
                }
            }).done(function () {
                $.when.apply($, deferreds).then(function () {
                    initComps();
                    initializeMasks();
                    initOrders();
                    ApproachCalculator.calculateCapComps();
                });
            });
        };

        var setCAPCompsFields = function () {
            setCompHandling();
            loadCompsInCAPComps();
            if(document.getElementById("save-evaluation"))
                document.getElementById("save-evaluation").addEventListener("click", saveComp);
            if($("#create-new-comp").length){
                document.getElementById("create-new-comp").addEventListener("click", createNewComp);
                loadSideNav();
                CompsController.loadSideNav();
            }
        };

        var saveComp = function () {
            var form = $("#evaluation-short-form");

            if (form.valid()) {
                unmaskFields();

                var data = new FormData(form[0]);

                if (form.find('#image').data('cropper') !== undefined) {
                    form.find('#image').cropper('getCroppedCanvas').toBlob(function (blob) {
                        var fileInput = form.find("input[name=photo][type=file]");

                        var filename = '';

                        if (fileInput.hasOwnProperty(0)) {
                            fileInput = fileInput[0];
                            if (fileInput.files) {
                                fileInput = fileInput.files;
                                if (fileInput.hasOwnProperty(0)) {
                                    fileInput = fileInput[0];
                                    if (fileInput.name) {
                                        filename = fileInput.name;
                                    }
                                }
                            }
                        }

                        if (filename.length === 0) {
                            filename = 'property_image_url';
                        }

                        data.append('property_image_url', blob, filename);

                        saveEvaluationDetails(data);
                    },"image/jpeg",0.75);
                } else {
                    saveEvaluationDetails(data);
                }

            } else {
                Materialize.toast('Please complete the missing fields.', 3000, 'blue');
            }
        };

        var saveEvaluationDetails = function (data) {
            $.ajax({
                type: "POST",
                url: $("body").data("base-url") + "evaluations/save",
                data: data,
                async:false,
                cache: false,
                contentType: false,
                processData: false,
                beforeSend: function (xhr) {
                    showLoading();
                },
                success: function (responseText) {
                    var evaluation = JSON.parse(responseText);

                    if (evaluation.id) {
                        saveToast();
                        location.reload();
                    }

                    // loadSideNav();
                },
                failure: function (errMsg) {
                    Materialize.toast("It was not possible to execute that action.", 2000);
                }
            }).done(function () {
                hideLoading();
                closeForm();
            });
        };

        $("#rounding").on('change', function() {
            var roundingVal = $(this).val();
            var acc;
            var roundVal;
            let roundSpaceVal;
            $.ajax({
                type: "POST",
                url: $("body").data("base-url") + "evaluations/save",
                async:false,
                data:{
                    'evaluation[id]': $("[name='evaluation[id]']").val(),
                    'evaluation[rounding]': roundingVal
                 },          
                success: function (responseText) {
                     var evaluation = JSON.parse(responseText);
                     var total = $("input[name=total_incremental_value]").data('value');   
                     var originalVal = $("input[name=total_incremental_value]").val();   
                     
                     if(roundingVal==3){
                        acc = 1000;
                     }else if(roundingVal==5000){
                        acc = 5000; 
                     }else if(roundingVal==4){
                        acc = 10000; 
                     }else if(roundingVal==5){
                        acc = 100000; 
                     }else if(roundingVal==6){
                        acc = 1000000; 
                     }   

                    if(roundingVal!=0)
                        roundVal = roundNearest(total,acc); 
                    else    
                        roundVal = originalVal; 
                    $('#total_incremental_value').val(roundVal);
                    let roundedTotal = Math.round(total/acc)*acc;
                    if(acc){
                        let buildingSize = $("input[name='evaluation[building_size]']").val();

                        if($('#selected_comp_type').val() === 'land_only')
                            buildingSize = $("input[name='evaluation[land_size]']").val();

                        roundSpaceVal = 0;
                        if(buildingSize > 0){
                            roundSpaceVal = parseFloat(roundedTotal).toFixed(2)/parseFloat(buildingSize);
                        }
                        
                        roundSpaceVal = roundSpaceVal.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2,style: 'currency', currency: 'USD' });
                        $('#total_incremental_space_val').val(roundSpaceVal);
                        if($('#comparison_basis_field').val() != 'SF'){
                            let roundCompBasisVal = 0;
                            let comparison_val = $('#comparison_basis_field').val().replace(/ /g, "_").toLowerCase();
                            let buildingSize = $('#comparison_basis_'+comparison_val+'_value').val();
                            if(buildingSize > 0)
                                roundCompBasisVal = parseFloat(roundedTotal).toFixed(2)/parseFloat(buildingSize); 
                            roundCompBasisVal = roundCompBasisVal.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2,style: 'currency', currency: 'USD' });
                            $('#total_incremental_'+comparison_val+'_val').val(roundCompBasisVal);
                        }
                    }else{
                        if($('#comparison_basis_field').val() != 'SF'){
                            let comparison_val = $('#comparison_basis_field').val().replace(/ /g, "_").toLowerCase();
                            $('#total_incremental_'+comparison_val+'_val').val($('#total_ppsf').val());
                            $('#total_incremental_space_val').val($('#total_ppsqft').val());
                        }else{
                            $('#total_incremental_space_val').val($('#total_ppsf').val());
                        }
                    }
                     
                    if (evaluation.id) {
                        saveToast();                       
                    }
                },
           });
        });

        var roundNearest = function (num, acc){            
            total = Math.round(num/acc)*acc;
            return  total.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2,style: 'currency', currency: 'USD' });                
        };
         
        var closeForm = function () {
            $('#evaluation-sidenav').sideNav('hide');
            $("#evaluation-short-form").validate().resetForm();
        };

        var showLoading = function () {
            $('#evaluation-sidenav').LoadingOverlay("show",
                {
                    image: $('body').attr('data-base-url') + "assets/img/loading.png",
                    imageAnimation: '2500ms rotate_left',
                    zIndex: 9999,
                    background: "rgba(255, 255, 255, 0.95)"
                }
            );
        };

        var hideLoading = function () {
            $('#evaluation-sidenav').LoadingOverlay("hide");
        };

        var showAdvanceLoading = function () {
            $('body').LoadingOverlay("show",
                {
                    image: $('body').attr('data-base-url') + "assets/img/loading.png",
                    imageAnimation: '2500ms rotate_left',
                    zIndex: 1005,
                    background: "rgba(255, 255, 255, 0.95)"
                }
            );
        };

        var hideAdvanceLoading = function () {
            $('body').LoadingOverlay("hide");
        };

        var setCostApproachImprovementEvaluationFields = function () {
            $(".cost-approach-improvement").keyup(_.debounce(ApproachCalculator.calculateCostApproach, 500));
            $(".cost-approach-improvement").on('keyup',function(){
                currentval = $(this).val();
                if (previousval !== currentval) {
                    dataToSave=true;
                }
            });
            $("input[name='evaluation[cost_approach_improvement][remodel_effect]']").keyup(_.debounce(ApproachCalculator.calculateAge, 500));

            //Operating Expense Entry Controller
            $(document).on('click', '.delete-cost-approach-improvement', function () {
                var cost_aproach_improvement_entry = $(".cost-approach-improvement-entry");
                if (cost_aproach_improvement_entry.length !== 1) {
                    $(this).closest('.cost-approach-improvement-entry').remove();
                } else {
                    $(this).closest('.cost-approach-improvement-entry').find('input').val("");
                }
                ApproachCalculator.calculateCostApproach();
                dataToSave=true;
            });

            $(document).on('click', '.add-new-cost-approach-improvement', function () {
                var last_improvement_entry = $('.cost-approach-improvement-entry').last();
                var income_source_row = last_improvement_entry.clone();

                income_source_row.find("input").val("");

                income_source_row.find("input").each(function (i, el) {
                    $(el).removeAttr('readonly');
                    $(el).removeAttr('data-id');
                    $(el).removeClass('disabled-input');
                    // $(el).removeClass('disabled-improvement');
                    if ($(el).attr('name') == 'evaluation[cost_approach_improvement][improvements][index][adjusted_cost]') {
                        $(el).prop('readonly', true);
                        $(el).addClass('disabled-input');
                    }

                    // if ($(el).attr('name') == 'evaluation[cost_approach_improvement][improvements][index][depreciation]') {
                    //     $(el).addClass('percentage');
                    // }

                    $(el).removeClass('count-total-sf-area');
                });

                income_source_row.find('.delete-cost-approach-improvement').removeClass('hide');

                last_improvement_entry.after(income_source_row);

                $(".cost-approach-improvement").change(_.debounce(ApproachCalculator.calculateCostApproach, 500));

                initializeMasks(true);
            });
        };

        var setCompsColors = function () {
            $('.comp-entry').each(function (index) {
                if (((index) % 2) === 0) {
                    $(this).find('.evaluation-approach-property').addClass("comps-background");
                } else {
                    $(this).find('.evaluation-approach-property').removeClass("comps-background");
                }
            });
        };

        var initializeDropdowns = function () {
            $(document).ready(function () {
                $('select').material_select();
                $(".sales-comps-field").change(_.debounce(ApproachCalculator.calculateSalesApproach(), 500));
                $(".cost-comps-field").change(_.debounce(ApproachCalculator.calculateCostApproach, 500));
            });
        };

        var onSelectComp = function (id) {
            $('#select-comp').modal('close');

            var autocompleteField = $('#autocomplete-comps');
            autocompleteField.val('');
            autocompleteField.data('id', '');

            loadCompEntry(id);
        };

        var onSelectClient = function (id) {
            if (id !== null && id !== 'undefined') {
                window.location.href = createURI('overview', null, { client: id });
            }
        };

        var loadCompEntry = function (id,update=0,units=0) {
            $.ajax({
                type: "GET",
                async:false,
                url: $("body").data("base-url") + "comps/getComps",
                data: { id: id, 'normalize': true },
                success: function (responseText) {
                    var comp = JSON.parse(responseText);
                    if(update==1)
                    {
                        $.each(comp, function(i, item) {
                            updateExistingComp(item,1,units);
                        });
                    }else{
                        $.each(comp, function(i, item) {
                            addNewComp(item,1,units);
                        });
                        dataToSave=true;
                    }
                },
                failure: function (errMsg) {
                    console.error("error:" + errMsg);
                    hideAdvanceLoading();
                }
            }).done(function () {
                hideAdvanceLoading();
            });
        };

        var selectComps = function() {
            var ids=[];
            let units=[];
            var count=0;
            if($('#results_format').is(':checked')){
                count = map_comps_ids.length;
                ids = map_comps_ids;
                units = map_comps_unit_ids;
            }else{
                $('.select_comp').each(function() {
                    if($(this).is(":checked") )
                    {
                        ids.push($(this).val());
                        units.push({id: $(this).val(), unit_id: $(this).attr('name')});
                        count++;
                    }
                });
            }
            if((location.pathname.indexOf('/multiFamilyComps') !== -1 && map_comps_unit_ids.length != 0 && map_comps_unit_ids[0].unit_id == 0) || !count ){
                return Materialize.toast('Please select comps.', 3000, 'red');
            }

            var length=$(".comp-entry").length;
            count=count+length;
            if(count>4)
            {
                if(length==0)
                {
                    Materialize.toast('You can only link a maximum of 4 comps.', 3000, 'red'); 
                }else{
                    var max=4-length;
                    Materialize.toast(length+' already selected. Now you can only link a maximum of '+max+' comps.', 3000, 'red'); 
                }
            }else{
                $('#select-comp').modal('close');
                loadCompEntry(ids, 0, units);
                clearFilters();
            }
        };
        $(".modal-close").click(function () {
            if(location.pathname.indexOf('/review')!= -1){
                clearEvalFilter();
            }else{
                clearFilters();
                $("#flag").val("0");
            }
        });
        
        var clearEvalFilter = function () {
            $('.advance_search_btn').addClass('hide');
            $('.advance_filter_form').removeClass('hide');
            $('.get_evals').removeClass('hide');
            $('#eval_search_mode').prop('checked',false);
            $("#eval_tbl_wrap").hide();
            $("#eval_data tr").remove();
            $('[name="street_address"]').val("");
            $('[name="street_address"]').parent().find('label').removeClass('active');
            $('[name="start_date"]').val("");
            $('[name="start_date"]').parent().find('label').removeClass('active');
            $('[name="end_date"]').val("");
            $('[name="end_date"]').parent().find('label').removeClass('active');
        };
        
        var clearFilters = function () {
            map_comps_ids = [];
            map_comps_unit_ids = [];
            $('.advance_search_btn').addClass('hide');
            $('.advance_filter_form').removeClass('hide');
            $('.get_comps').removeClass('hide');
            var comp_type = $('select[name="comp_type"]');
            comp_type.val("sale");
            comp_type.material_select();
            var property_type = $('select[name="property_type"]');
            property_type.val("");
            property_type.material_select();
            var property_sub_type = $('select[name="property_sub_type"]');
            property_sub_type.val("");
            property_sub_type.material_select();
            var state = $('select[name="state"]');
            state.val("");
            state.material_select();
            var city = $('select[name="city[]"]');
            city.val("");
            city.material_select();
            $('#results_format').prop('checked', false); 
            $("#comp_tbl_wrap").hide();
            $("#comp_data tr").remove();
            $('[name="filter_street_address"]').val("");
            $('[name="filter_street_address"]').parent().find('label').removeClass('active');
            $('[name="start_date"]').val("");
            $('[name="start_date"]').parent().find('label').removeClass('active');
            $('[name="end_date"]').val("");
            $('[name="end_date"]').parent().find('label').removeClass('active');
            $('[name="square_footage_min"]').val("");
            $('[name="square_footage_min"]').parent().find('label').removeClass('active');
            $('[name="square_footage_max"]').val("");
            $('[name="square_footage_max"]').parent().find('label').removeClass('active');
            $('[name="land_sf_min"]').val("");
            $('[name="land_sf_min"]').parent().find('label').removeClass('active');
            $('[name="land_sf_max"]').val("");
            $('[name="land_sf_max"]').parent().find('label').removeClass('active');
            $('[name="cap_rate_min"]').val("");
            $('[name="cap_rate_min"]').parent().find('label').removeClass('active');
            $('[name="cap_rate_max"]').val("");
            $('[name="cap_rate_max"]').parent().find('label').removeClass('active');
        };
        var initialize = function () {
            $('#evals-table').DataTable({
                "searching": true,
                "lengthChange": false,
                "pagination": true,
                "order": [[3, 'desc']],
            });
            $('#comps-modal-table').DataTable({
                "searching": false,
                "lengthChange": false,
                "pagination": false,
                // "order": [[8, 'desc']],
                "paginate": false,
            });
            initializeForms();
            if($('#add_adjustment').length)
                document.getElementById("add_adjustment").addEventListener("click", saveNotes);
        };
        var saveNotes = function(e){
            e.preventDefault();
            var form = $("#add_adjustment_form");
            var data = new FormData(form[0]);
            if (form.valid()) {
                $.ajax({
                    type: "POST",
                    url: $("body").data("base-url") + "evaluations/saveNotes",
                    data: data,
                    cache: false,
                    contentType: false,
                    processData: false,
                    success: function (responseText) {
                        $('.add_adjustment_close').click();
                        var adjustment_note_text = $('#adjustment_note').val();
                        if(adjustment_note_text=="")
                            $(adjustment_input_text).html("Click to add "+notes_link+" notes");
                        else
                            $(adjustment_input_text).html("Click to edit "+notes_link+" notes");
                        $(adjustment_note).val(adjustment_note_text);
                        if(adjustment_note !="")
                            $(adjustment_link).addClass('hide');
                        return false;
                    },
                    failure: function (errMsg) {
                        Materialize.toast("It was not possible to execute that action.", 2000);
                    }
                });
            }
        };

        var evaluation_url = function (step) {
            var id = $('input[name="evaluation[id]"]').val();
            var client = $('input[name="evaluation[client_id]"]').val();

            if (id) {
                return createURI(step, id);
            } else if (client) {
                return createURI(step, null, { id: client });
            } else {
                return createURI(step);
            }
        };

        var setIndexes = function (key, totalOfInputs) {
            var counter = 0;
            var index = 0;
            var elements = document.getElementsByClassName(key);

            for (var idx = 0; idx < elements.length; idx++) {
                if (elements[idx].nodeName !== 'DIV') {
                    if (elements[idx].name) {
                        elements[idx].name = elements[idx].name.replace('index', counter);
                    }

                    index++;

                    if (index % totalOfInputs === 0) {
                        counter++;
                    }
                }
            }
            return true;
        };

        var setBreadcrumb = function () {
            $(document).on('click', '.evaluations-next', function () {
                unmaskFields();
                var form = $('#evaluation-form');
                send(form);
            });

            $(document).on('click', '.evaluations-previous', function () {
                unmaskFields();
                var form = $('#evaluation-form');
                var url = evaluation_url(form.attr('data-previous'));
                send(form, url);
            });

            $(document).on('click', '.evaluations-previous-skip', function () {
                startLoading('body');
                var form = $('#evaluation-form');
                window.location.href = evaluation_url(form.attr('data-previous'));
            });

            $(document).on('click', '.evaluations-next-skip', function () {
                startLoading('body');
                var form = $('#evaluation-form');
                window.location.href = evaluation_url(form.attr('data-next'));
            });

            $('body.evaluations #evaluation-form').on('focus', '.select-dropdown', function () {
                previousval = $(this).val();
            });

            $('body.evaluations #evaluation-form').on('change', 'select,input[type=checkbox]', function () {
                var form = $('#evaluation-form');
                if ((location.pathname.indexOf('/overview') == -1) && (location.pathname.indexOf('/sales') == -1) && (location.pathname.indexOf('/cost') == -1) && (location.pathname.indexOf('/leaseComps') == -1) && (location.pathname.indexOf('/capComps') == -1  && (location.pathname.indexOf('/multiFamilyComps') == -1))) {
                    send(form, false, true);
                }else{
                    currentval = $(this).val();
                    if (previousval !== currentval) {
                        dataToSave=true;
                    }
                }
            });
            $('body.evaluations #evaluation-form').on('change', 'input[type=checkbox]', function () {
                setDefaultWeight();
            });

            $('body.evaluations #evaluation-form').on('focus', '.wysiwyg .evalsummary,.wysiwyg .evalzoning,.wysiwyg .evalreview', function () {
                previousval = $(this).text();
            });

            $('body.evaluations #evaluation-form').on('focus', '.standalone-datepicker,.evalyear,.evalbaseyear,.ceiling', function () {
                previousval = $(this).val();
            });
            $('body.evaluations #evaluation-form').on('blur', '.wysiwyg .evalsummary,.wysiwyg .evalzoning,.wysiwyg .evalreview', function () {
                currentval = $(this).text();
                if (previousval == currentval) {
                    return false;
                }
                // unmaskFields();
                var form = $('#evaluation-form');
                if (location.pathname.indexOf('/overview') == -1) {
                    send(form, false, true);
                }else{
                    if (previousval !== currentval) {
                        dataToSave=true;
                    }
                }
            });

            $('body.evaluations #evaluation-form').on('click', '.wysiwyg .ql-formats', function () {
                currentval = $(this).text();
                if (previousval == currentval) {
                    return false;
                }
                var form = $('#evaluation-form');
                send(form, false, true);
            });

            $('body.evaluations #evaluation-form').on('blur keyup', '.evalyear,.evalbaseyear,.evalceiling', function () {
                currentval = $(this).val();
                if (previousval == currentval) {
                    return false;
                }
                var form = $('#evaluation-form');
                if (location.pathname.indexOf('/overview') == -1) {
                    send(form, false, true);
                }else{
                    currentval = $(this).val();
                    if (previousval !== currentval) {
                        dataToSave=true;
                    }
                }
            });
            $('body.evaluations #evaluation-form').on('focus', 'input[type=text]:not(.select-dropdown,#route),input[type=radio]:not(.select-dropdown)', function () {
                previousval = $(this).val();
            });

            $(document).on('click','.remove-entry-button-suffix',function(){
                if (location.pathname.indexOf('/income') !== -1) {
                    dataToSave=true;
                }
            });

            $(document).on('click','.delete-additional-feature, .delete-additional-traffic-count',function(){
                if (location.pathname.indexOf('/overview') !== -1) {
                    dataToSave=true;
                }
            });
            $('body.evaluations #evaluation-form').on('change', '.wysiwyg .textarea,textarea,input[type=text]:not(.select-dropdown,#route),input[type=radio]:not(.select-dropdown)', function () {
                var form = $('#evaluation-form');
                //TODO: fix ugly code is here just to fix some weird jqueryMask issues...
                $('.currency').maskMoney('mask');
                $('.currency').maskMoney('unmasked');

                $('.currency').maskMoney({
                    prefix: '$',
                    allowNegative: true,
                    thousands: ",",
                    decimal: ".",
                    affixesStay: true,
                    formatOnBlur: true,
                    selectAllOnFocus: true,
                    // reverse: true,
                    allowZero: true,
                    defaultZero: true,
                    bringCaretAtEndOnFocus: false
                });
                $('.currency').maskMoney('mask');
                if ((location.pathname.indexOf('/income') == -1) && (location.pathname.indexOf('/overview') == -1) && (location.pathname.indexOf('/sales') == -1) && (location.pathname.indexOf('/cost') == -1) && (location.pathname.indexOf('/leaseComps') == -1) && (location.pathname.indexOf('/capComps') == -1 && (location.pathname.indexOf('/multiFamilyComps') == -1))) {
                    send(form, false, true);
                }else{
                    currentval = $(this).val();
                    if ((previousval !== currentval) || $(this).is(":radio")) {
                        dataToSave=true;
                    }
                    var data = ViewManager.extractData(form);
                    data = checkForUnchecked(data);
                }
            });
        };

        var checkForUnchecked = function (data) {
            var incomeApproachCheckBox = $("input[name='evaluation[has_income_approach]']");
            if (incomeApproachCheckBox.length && !incomeApproachCheckBox.prop('checked')) {
                data['evaluation[has_income_approach]'] = false;
            }

            var salesApproachCheckBox = $("input[name='evaluation[has_sales_approach]']");
            if (salesApproachCheckBox.length && !salesApproachCheckBox.prop('checked')) {
                data['evaluation[has_sales_approach]'] = false;
            }

            var costApproachCheckbox = $("input[name='evaluation[has_cost_approach]']");
            if (costApproachCheckbox.length && !costApproachCheckbox.prop('checked')) {
                data['evaluation[has_cost_approach]'] = false;
            }
            var has_lease_comps = $("input[name='evaluation[has_lease_comps]']");
            if (has_lease_comps.length && !has_lease_comps.prop('checked')) {
                data['evaluation[has_lease_comps]'] = false;
            }
            var has_cap_comps = $("input[name='evaluation[has_cap_comps]']");
            if (has_cap_comps.length && !has_cap_comps.prop('checked')) {
                data['evaluation[has_cap_comps]'] = false;
            }
            var has_multi_family = $("input[name='evaluation[has_multi_family]']");
            if (has_multi_family.length && !has_multi_family.prop('checked')) {
                data['evaluation[has_multi_family]'] = false;
            }
            var hasSuiteParcelCheckbox = $("input[name='evaluation[has_suite_parcel]']");
            if (hasSuiteParcelCheckbox.length && !hasSuiteParcelCheckbox.prop('checked')) {
                data['evaluation[has_suite_parcel]'] = false;
            }

            var lastTransferDateKnown = $("input[name='evaluation[last_transfer_date_known]']");
            if (lastTransferDateKnown.length){ 
                if(!lastTransferDateKnown.prop('checked')) {
                    data['evaluation[last_transfer_date_known]'] = 'no';
                    $('input[name ="evaluation[under_contract_price]"]').parent('.input-field').find('label').addClass('active');
                    $('input[name ="evaluation[price]"]').parent('.input-field').find('label').addClass('active');
                    $('#evaluation_last_transferred_date_field').hide();
                    $('input[name="evaluation[last_transferred_date]"]').val('');
                } else {
                    data['evaluation[last_transfer_date_known]'] = 'yes';
                    $('input[name ="evaluation[under_contract_price]"]').parent('.input-field').find('label').addClass('active');
                    $('input[name ="evaluation[price]"]').parent('.input-field').find('label').addClass('active');
                    $('#evaluation_last_transferred_date_field').show();
                }
            }

            var comp_type = $("input[name='evaluation[comp_type]']");
            if (comp_type.length) {
                data['evaluation[comp_type]'] = $("input[name='evaluation[comp_type]']:checked").val();
            }

            return data;
        };

        $("[name='included_utilities[]']").change(_.debounce(function () {
            let selectedValue = $(this).val();
            $("#included_utilities").val(selectedValue);
            $(this).material_select();
        }, 1500));

        var send = function (form, url, donotreload = false) {
            if (isInArray('exhibits', segments)) { //EXHIBITS PAGE
                startLoading('body');
                var formData = new FormData(form[0]);

                $.ajax({
                    url: form.attr('action'),
                    type: 'POST',
                    xhr: function () {
                        var myXhr = $.ajaxSettings.xhr();
                        return myXhr;
                    },
                    success: function (responseText) {
                        stopLoading('body');
                        var response = JSON.parse(responseText);

                        if (response.status.localeCompare("success") === 0) {
                            saveToast();
                            if (url) {
                                window.location.href = url;
                            } else {
                                window.location.href = createURI(form.attr('data-next'), response.id);
                            }
                        } else {
                            Materialize.toast(response.message);
                        }
                    },
                    data: formData,
                    cache: false,
                    contentType: false,
                    processData: false

                }).done(function () {
                    focusInPostMasks();
                });
            } else {
                var valid = false;

                if (isInArray('overview', segments)) { //IF OVERVIEW FORM, VALIDATE IT
                    Utils.setIndexes('zonings', 8);
                    Utils.setIndexes('property_unit', 5);
                    valid = form.valid();
                    Utils.unsetIndexes('zonings', 8);
                    Utils.unsetIndexes('property_unit', 5);
                } else {
                    valid = true;
                }

                if (valid) {
                    if(check_multi == true && $('#comparison_basis').val() == 'Unit')
                    { 
                        if(!ApproachCalculator.checkPropertyType()){
                            focusInPostMasks();
                            return Materialize.toast('At least one property type should be Multi-family.', 3000, 'red');
                        }else 
                        if(!ApproachCalculator.check_unit_val){
                            focusInPostMasks();
                            return Materialize.toast('Total Multi-Family "# of Units" is not equal to the total "Unit Count".', 3000, 'red');
                        }
                    }

                    if (!donotreload) {
                        // startLoading('body');
                    }

                    var data = ViewManager.extractData(form);

                    data = checkForUnchecked(data);

                    $.ajax({
                        type: 'POST',
                        url: form.attr('action'),
                        data: data,
                        success: function (responseText) {
                            stopLoading('body');
                            var response = JSON.parse(responseText);

                            if (response.status.localeCompare("success") === 0) {
                                saveToast();
                                if (!donotreload) {
                                    if (url) {
                                        window.location.href = url;
                                    } else {
                                        window.location.href = createURI(form.attr('data-next'), response.id);
                                    }
                                }
                            }
                            else {
                                Materialize.toast(response.message,3000);
                            }
                        },
                        error: function (responseText) {
                            window.location.href = url;
                        }
                    }).done(function () {
                        focusInPostMasks();
                    });
                } else {
                    focusInPostMasks();
                    Materialize.toast('There are required fields to be filled. Check them before you proceed.', 2000, 'red');
                    e.preventDefault();
                    return false;
                }
            }
            // focusInPostMasks();
        };

        var save = function (form) {
            var noComps = '';

            if (isInArray('sales', segments)) {
                if ($('#evaluation-form').find("[name='evaluation[sales_approach][comps][index][comp_id]']").length === 0) {
                    noComps = '&evaluation%5Bsales_approach%5D%5Bcomps%5D=';
                }
                setIndexes('sales-comps-field', 14);
            } else if (isInArray('cost', segments)) {
                // if ($('#evaluation-form').find("[name='evaluation[cost_approach][comps][index][id]']").length === 0) {
                if ($('#evaluation-form').find("[name='evaluation[cost_approach][comps][index][comp_id]']").length === 0) {
                    noComps = '&evaluation%cost_approach%5D%5Bcomps%5D=';
                }
                setIndexes('cost-comps-field', 12);
            }

            $.ajax({
                type: 'POST',
                url: form.attr('action'),
                async:false,
                data: form.serialize() + noComps,
                success: function (responseText) {
                    var response = JSON.parse(responseText);

                    if (response.status.localeCompare("success") === 0) {
                        saveToast();
                    }
                }
            }).done(function () {
                if (isInArray('sales', segments)) {
                    unsetIndexes('sales-comps-field');
                } else if (isInArray('cost', segments)) {
                    unsetIndexes('cost-comps-field');
                }
            });
        };

        var unsetIndexes = function (className) {
            $('.' + className).each(function (i, e) {
                var el = $(e);

                var name = el.attr('name');
                if (name) {
                    name = name.replace(/[0-9]+/g, "index");
                    el.attr('name', name);
                }
            });
        };

        var createURI = function (nextStep, id, params) {
            if (nextStep) {
                var ret = [];
                for (var d in params) {
                    if (params.hasOwnProperty(d)) {
                        ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(params[d]));
                    }
                }
                if (id && params) {
                    return $("body").data("base-url") + "evaluations/" + nextStep + '/' + id + '?' + ret.join('&');
                } else if (id && !params) {
                    return $("body").data("base-url") + "evaluations/" + nextStep + '/' + id;
                } else {
                    return $("body").data("base-url") + "evaluations/" + nextStep + '?' + ret.join('&');
                }
            } else {
                return $("body").data("base-url") + "evaluations/";
            }
        };

        var initType = function () {
            var typeEl = $('select[name="evaluation[cost_approach_improvement][type]"]');
            typeEl.change(function () {
                var type = $(this).val();
                setType(type);
            });
            setType(typeEl.val());
        };

        var setType = function (type) {
            var simple = $('[data-cost-approach-type=simple]');
            var advanced = $('[data-cost-approach-type=advanced]');

            if (type === 'simple') {
                simple.removeClass('hide');
                advanced.addClass('hide');

                $('[data-simple-cost-approach-size]').each(function (i, el) {
                    var newSize = $(el).data('simple-cost-approach-size');
                    var oldSize = $(el).data('advanced-cost-approach-size');

                    $(el).addClass(newSize);
                    $(el).removeClass(oldSize);
                });

                $("[name='evaluation[cost_approach_improvement][improvements][index][adjusted_psf]']").removeAttr('readonly');
                $("[name='evaluation[cost_approach_improvement][improvements][index][adjusted_psf]']").removeClass('disabled-input');
            } else if (type === 'advanced') {
                simple.addClass('hide');
                advanced.removeClass('hide');

                $('[data-advanced-cost-approach-size]').each(function (i, el) {
                    var newSize = $(el).data('advanced-cost-approach-size');
                    var oldSize = $(el).data('simple-cost-approach-size');

                    $(el).addClass(newSize);
                    $(el).removeClass(oldSize);
                });

                $("[name='evaluation[cost_approach_improvement][improvements][index][adjusted_psf]']").attr('readonly', 'readonly');
                $("[name='evaluation[cost_approach_improvement][improvements][index][adjusted_psf]']").addClass('disabled-input');
            }

            ApproachCalculator.calculateCostApproach();
        };

        var openForm = function (id) {
            fillInputs(id);
        };

        var fillInputs = function (id) {
            $.ajax({
                type: "GET",
                url: $("body").data("base-url") + "evaluations/get",
                data: { id: id },
                success: function (responseText) {
                    var evaluation = JSON.parse(responseText);
                    if (evaluation.id) {
                        for (var property in evaluation) {
                            if (evaluation.hasOwnProperty(property)) {
                                var input = $("[name=\"evaluation[" + property + "]\"]");

                                if (input.is("input")) {
                                    input.val(evaluation[property]);
                                    $("label[for='evaluation[" + property + "]']").addClass("active");
                                } else if (input.is("select")) {
                                    input.val(evaluation[property]).change();
                                    input.material_select();
                                } else if (input.is("textarea")) {
                                    input.val(evaluation[property]).change();
                                } else {
                                    if (property.indexOf('photo') === 0) {
                                        if (evaluation[property]) {
                                            setImage(evaluation, property);
                                        }
                                    }
                                }

                            }
                        }
                    }
                }
            }).done(function () {
                setEvaluationType();
            });
        };

        var setImage = function (evaluation, property) {
            var url = $("body").data("cdn-url") + evaluation[property];
            var preloaderImg = document.createElement("img");
            preloaderImg.src = url;

            preloaderImg.addEventListener('load', function (event) {
                var output = $('.comps-image-container');

                output.css("background-image", "url('" + url + "')");
                output.css("background-size", "auto 100%");
                output.css("background-position", "center");
                output.css("background-color", "#f9f9f9");
                output.css("background-repeat", "no-repeat");

                $(".comps-image").fadeTo("fast", 0);
            });

            preloaderImg.addEventListener('error', function () {
                $('.comps-image-container').children().first().css('opacity', 1);
            });
        };

        $("select[name='city[]']").change(_.debounce(function () {
            $(this).material_select();
        }, 1800));

        var initImageCropper = function () {
            $('input[name=photo][type=file]').change(function () {
                var input = this;
                var url = $(this).val();
                var ext = url.substring(url.lastIndexOf('.') + 1).toLowerCase();

                if (input.files && input.files[0] && (ext === "gif" || ext === "png" || ext === "jpeg" || ext === "jpg")) {
                    var reader = new FileReader();

                    reader.onload = function (e) {
                        var imgContainer = $('#evaluation-short-form').find('#image');
                        imgContainer.attr('src', e.target.result);
                        imgContainer.cropper({
                            aspectRatio: 16 / 9
                        });

                        $('#evaluation-short-form').find('.comps-image-container > .file-field').hide();
                    };

                    reader.readAsDataURL(input.files[0]);
                }
            });
        };
        $(document).on('click','.btn_link',function(e){
            window.onbeforeunload = null;
            // e.preventDefault();
            e.stopPropagation();
            if($(this).attr('id')=="save_changes")
            {
                if (location.pathname.indexOf('/income') !==-1){
                    ViewManager.save();
                }else{
                    var form = $('#evaluation-form');
                    send(form, false, true);
                }
            }
            if($(this).attr('data-object') === undefined ){
                window.location.href = document.referrer;
                window.history.back();
            }
            window.location.href = $(this).attr('data-object');
        });
        
        if (window.EvaluationController === undefined) {
            window.EvaluationController = {};
        }

        $(document).on('click', '.add_adjustment_close', function(){
            $('#adjustment_note').parent().find('label').removeClass('active');
        });
        $('#income_approach').change(function () {
            if($(this).prop('checked')==true)
            {
                $('.if_income_approach').removeClass('hide');
            }
            else{
                $('.if_income_approach').addClass('hide');
            }
            check_cap_comp_display();
        });
        $(document).on('click','#eval_multi_family', function () {
            if($(this).prop('checked')==true)
            {
                $("select[name='evaluation[comparison_basis]'] option[value='SF']").attr('selected',false);
                let option = $("select[name='evaluation[comparison_basis]']").val('Unit').change().prop('disabled', 'disabled');
                option.material_select();
                // $('.unit-section').removeClass('hide');
                $('.if-multi-family').removeClass('hide');
                check_multi = true;
            }else{
                $("select[name='evaluation[comparison_basis]']").removeAttr("disabled").val();
                $("select[name='evaluation[comparison_basis]']").material_select();
                // if( $("select[name='evaluation[comparison_basis]']").val() != 'Unit'){
                    $('.unit-section').addClass('hide');
                // }
                $('.if-multi-family').addClass('hide');
                check_multi = false;
            }
        });
        $(document).on('click', '.open_add_adjustment_modal', function () {
            if($(this).attr('data')){
                $('.notes_title').text($(this).attr('data'));
            }
            $('#add_adjustment_modal').modal('open');
            $('#adjustment_note').parent().find('label').removeClass('active');
            var comp_id = $(this).parents('.comps').find('[name="evaluation[sales_approach][comps][index][id]"]').val();
            var eval_order = $(this).parents('.comps').find('[name="evaluation[sales_approach][comps][index][order]"]').val();
            $('#add_adjustment_modal').find('#eval_screen_type').val('sale');
            
            if (location.pathname.indexOf('/capComps') !== -1){
                comp_id = $(this).parents('.comps').find('[name="evaluation[cap_comps][comps][index][id]"]').val();
                eval_order = $(this).parents('.comps').find('[name="evaluation[cap_comps][comps][index][order]"]').val();
                $('#add_adjustment_modal').find('#eval_screen_type').val('capComp');
            }else if (location.pathname.indexOf('/leaseComps') !== -1){
                comp_id = $(this).parents('.comps').find('[name="evaluation[lease_comps][comps][index][id]"]').val();
                eval_order = $(this).parents('.comps').find('[name="evaluation[lease_comps][comps][index][order]"]').val();
                $('#add_adjustment_modal').find('#eval_screen_type').val('leaseComps');
            }else if (location.pathname.indexOf('multiFamilyComps') !== -1){
                comp_id = $(this).parents('.comps').find('[name="evaluation[multi_family_approach][comps][index][id]"]').val();
                eval_order = $(this).parents('.comps').find('[name="evaluation[multi_family_approach][comps][index][order]"]').val();
                $('#add_adjustment_modal').find('#eval_screen_type').val('multiFamilyComps');
            }
            $('#add_adjustment_modal').find('#adjustment_comp_id').val(comp_id);
            $('#add_adjustment_modal').find('#eval_order').val(eval_order);
            var eval_id = $('[name="evaluation[id]"]').val();
            var note ='';
            notes_link = 'adjustment';
            if(comp_id !== undefined){
                if (location.pathname.indexOf('/capComps') !== -1){
                    notes_link = 'weighting';
                }
                note = $(this).parents('.comps').find('.adjustment_note').val();
                adjustment_input_text = $(this).parents('.comps').find('.adjustment_input_text');
                adjustment_note = $(this).parents('.comps').find('.adjustment_note');
                adjustment_link = $(this).parents('.comps').find('.adjustment_link');
            }
            else{
                if (location.pathname.indexOf('/leaseComps') !== -1){
                    notes_link = 'property';
                }else if (location.pathname.indexOf('/capComps') !== -1){
                    notes_link = 'CAP Rate';
                }
                note = $(this).parents('.comp-current').find('.adjustment_note').val();
                adjustment_input_text = $(this).parents('.comp-current').find('.adjustment_input_text');
                adjustment_note = $(this).parents('.comp-current').find('.adjustment_note');
                adjustment_link = $(this).parents('.comp-current').find('.adjustment_link');
            }
            $('#adjustment_note').val(note);
            if(note!="")
                $('#adjustment_note').parent().find('label').addClass('active');
            $('#add_adjustment_modal').find('#adjustment_eval_id').val(eval_id);
        });
        
        EvaluationController.closeForm = closeForm;
        EvaluationController.createURI = createURI;
        EvaluationController.unsetIndexes = unsetIndexes;
        EvaluationController.setIndexes = setIndexes;
        EvaluationController.initPropertyTypeSqftEvent = initPropertyTypeSqftEvent;
        EvaluationController.loadCompEntry = loadCompEntry;

        initialize();
    }
});

/*Callback function called by the Google Maps API*/
function initializeEvaluationsMap() {
    MapController.Evaluations.init();
}

function fillMultipleSelect(data, name, defaultText) {
    var response = JSON.parse(data);

    var select = $('select[name="' + name + '[]"]');

    if (select) {
        select.find('option').remove();

        select.append($("<option value disabled selected>" + defaultText + "</option>"));

        $(response).each(function (index, instance) {
            if (instance.val && instance.text) {
                var selected="";
                if(($("#city_name").val()==instance.val) && ($("#state").val()!="") && ($("#flag").val()==0))
                {
                    selected="selected";
                    $("#flag").val("1");
                }
                // select.append($(option, {value: instance.val, text: instance.text}));
                select.append('<option value="'+instance.val+'" '+selected+'>'+instance.text+'</option>');
            }
        });

        var value = getUrlParameter(name);

        var values = [];
        if (value && value.length > 0) {
            values = value.split(",");
            select.val(values);

            values.forEach(function (item) {
                if ($("select[name='" + name + "[]'] option[value='" + item + "']").length === 0) {
                    cleanSearchQuery(name);
                }
            });
        } else {
            cleanSearchQuery(name);
        }

        select.material_select();
    }
}

function getUrlParameter(sParam) {
    var sPageURL = decodeURIComponent(window.location.search.substring(1)),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : sParameterName[1];
        }
    }
}

function cleanSearchQuery(attribute) {

    if (attribute !== undefined) {
        //Remove the specific attribute from the GET params list and set
        //the attribute to its default if any
        if ($("article.listing-template").length > 0) {
            $.query = $.query.REMOVE(attribute);
            setInputDefault(attribute);
        }
    } else {
        //Empty the query string with GET params
        $.query = $.query.empty();
    }

    history.pushState(null, '', window.location.pathname + $.query);
}

function change_property(obj) {
    var value = $(obj).val();
    var subType = $("select.property_sub_type").attr('data-subtype');
    var sub = $.parseJSON(subType);
    var options = '';

    if (typeof sub[value] !== 'undefined') {

        var children = sub[value].children;
        if (typeof children !== 'undefined') {
            for (var child in children) {
                options += "<option value='" + child + "'>" + children[child] + "</option>";
                $("select.property_sub_type").attr('disabled', false);
            }
        } else {
            options = "<option value='0'>No Subtypes</option>";
            $("select.property_sub_type").attr('disabled', true);
        }
    }
    else {
        options += "<option value=''>-- Select a Subtype --</option>";
    }
    $("select.property_sub_type").html(options).material_select();
}

function change_state(obj)
{
    let url = 'evaluations/get_cities';
    if (location.pathname.indexOf('/res_comps') !== -1 || location.pathname.indexOf('/res_evaluations') !== -1)
        url = 'res_comps/get_cities';
    var state=$("#state").val();
    var params = { state: state};
    $.get($("body").data("base-url") + url, params).done(function (data) {
        if(data=="[]" && state!=="")
        {
            var selected_State=$("#state").find(":selected").text();
            fillMultipleSelect(data, 'city', 'No comps available in '+selected_State);
        }else{
            fillMultipleSelect(data, 'city', 'Select a City');
        }
        // When state is selected, update and enable city
        $('select[name="city[]"]')
            .prop('disabled', null)
            .material_select();
        
        reinitCitySelect();
    });
}

function reinitCitySelect() {
    $("[data-select='city']").find('ul.dropdown-content li').first().click(function(){
        $("[data-select='city']").find('ul.dropdown-content li:not(:first-child)').each(function(index) {
            $(this).find("input[type=checkbox]").prop("checked", false);
        });
        $("select[name='city[]']").val('');
        $("select[name='city[]']").material_select();
    });
}

function convert_to_dropdown(obj){
    $(obj).parent().children('.custom_field').val('');
    $(obj).parent().children('.custom_field').addClass('hide');
    $(obj).parent().children().children('select').val('0');
    $(obj).parent().children().children('select').material_select();
    $(obj).parent().children('.select-wrapper').removeClass('hide');
    var label = $(obj).parent().parent().children('.percentage-label').find('label');
    label.html('Equal');
    label.css("color", "#9e9e9e");
    label.css("font-weight", "normal");
    if (location.pathname.indexOf('/evaluations/sales') !== -1) {
        ApproachCalculator.calculateSalesApproach();
    }else if (location.pathname.indexOf('/evaluations/leaseComps') !== -1) {
        ApproachCalculator.calculateLeaseComps();
    }else if (location.pathname.indexOf('/evaluations/cost') !== -1) {
        ApproachCalculator.calculateCostApproach();
    }else if (location.pathname.indexOf('/evaluations/multiFamilyComps') !== -1) {
        ApproachCalculator.calculateMultiFamilyApproach();
    }
    $(obj).remove();
}